import type { NumInGroup } from './SpecGroups';

export type Ref = {
    id: number;
    added: string;
    presence?: string;
    addedEP?: string;
    updated?: string;
    updatedEP?: string;
    deprecated?: string;
    deprecatedEP?: string;
    description?: string;
};

export interface ISpecComponents {
    id: number;
    name: string;
    category: string;
    abbrName: string;
    description: string;
    added: string;
    fieldRef?: Ref[];
    groupRef?: Ref[];
    componentRef?: Ref[];
    numInGroup?: NumInGroup;
    addedEP?: string;
    updated?: string;
    updatedEP?: string;
    deprecated?: string;
    deprecatedEP?: string;
}

export const COMPONENTS: ISpecComponents[] = [
    {
        name: 'CommissionData',
        abbrName: 'Comm',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.3',
        updatedEP: '204',
        category: 'Common',
        id: 1000,
        fieldRef: [
            {
                added: 'FIX.4.3',
                id: 12,
            },
            {
                added: 'FIX.4.3',
                id: 13,
            },
            {
                updated: 'FIX.5.0SP1',
                added: 'FIX.4.3',
                updatedEP: '95',
                id: 479,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2922,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1233,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1238,
            },
            {
                updated: 'FIX.5.0SP1',
                added: 'FIX.4.3',
                updatedEP: '95',
                id: 497,
            },
        ],
        description:
            'The CommissionData component block is used to carry commission information such as the type of commission and the rate. Use the CommissionDataGrp component as an alternative if multiple commissions or enhanced attributes are needed.\n\nThis component may be used to provide aggregated commission data of a given CommType(13) where the CommissionDataGrp maybe used to include the detail splits provided the commission is of the same commission basis type. For example, CommissionData may contain CommType(13) of 3 (Absolute) and a Commission(12) value of "15". CommissionDataGrp may be used to show how this Commission(12) value of "15" is split up as long as the CommissionBasis(2642) is also 3 (Absolute) for each of the instances added together. This method of aggregated commission data may also be applied to this component to provide a total when the instances of the detail splits in CommissionDataGrp contain leg level information (indicated by the usage of CommissionLegRefID(2649) in CommissionDataGrp). Note that it is only possible to aggregate values for a single commission basis type.',
    },
    {
        name: 'DiscretionInstructions',
        abbrName: 'DiscInstr',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1001,
        fieldRef: [
            {
                added: 'FIX.4.4',
                id: 388,
            },
            {
                added: 'FIX.4.4',
                id: 389,
            },
            {
                added: 'FIX.4.4',
                id: 841,
            },
            {
                added: 'FIX.4.4',
                id: 842,
            },
            {
                added: 'FIX.4.4',
                id: 843,
            },
            {
                added: 'FIX.4.4',
                id: 844,
            },
            {
                added: 'FIX.4.4',
                id: 846,
            },
        ],
        description:
            'The presence of DiscretionInstructions component block on an order indicates that the trader wishes to display one price but will accept trades at another price.\n\n',
    },
    {
        name: 'FinancingDetails',
        abbrName: 'FinDetls',
        updated: 'FIX.5.0SP2',
        added: 'FIX.4.4',
        updatedEP: '161',
        category: 'Common',
        id: 1002,
        fieldRef: [
            {
                added: 'FIX.4.4',
                id: 913,
            },
            {
                added: 'FIX.4.4',
                id: 914,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1961,
            },
            {
                added: 'FIX.4.4',
                id: 915,
            },
            {
                added: 'FIX.4.4',
                id: 918,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2952,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1962,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1963,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1964,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1965,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1966,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1967,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1968,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1969,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1970,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1513,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1525,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1527,
            },
            {
                added: 'FIX.4.4',
                id: 788,
            },
            {
                added: 'FIX.4.4',
                id: 916,
            },
            {
                added: 'FIX.4.4',
                id: 917,
            },
            {
                added: 'FIX.4.4',
                id: 919,
            },
            {
                added: 'FIX.4.4',
                id: 898,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4003,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4005,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4004,
            },
        ],
        description:
            'Component block is optionally used for financial transaction where legal contracts, master agreements or master confirmations is to be referenced. This component identifies the legal agreement under which the deal was made and other unique characteristics of the transaction. For example, the AgreementDesc(913) field refers to base standard documents such as MRA 1996 Repurchase Agreement, GMRA 2000 Bills Transaction (U.K.), MSLA 1993 Securities Loan – Amended 1998, for example.\n\n',
    },
    {
        name: 'Instrument',
        abbrName: 'Instrmt',
        added: 'FIX.4.3',
        category: 'Common',
        id: 1003,
        fieldRef: [
            {
                updated: 'FIX.Latest',
                added: 'FIX.4.3',
                updatedEP: '277',
                id: 55,
                description:
                    'Common, "human understood" representation of the security. SecurityID value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\n\nUse "[N/A]" for products which do not have a symbol.\n\nRequired if the Instrument component is marked as required where the component is used.',
            },
            {
                added: 'FIX.4.3',
                id: 65,
            },
            {
                added: 'FIX.4.3',
                id: 48,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '161',
                id: 22,
            },
            {
                added: 'FIX.4.3',
                id: 460,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1227,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1151,
            },
            {
                added: 'FIX.4.3',
                id: 461,
            },
            {
                added: 'FIX.Latest',
                addedEP: '266',
                id: 2891,
            },
            {
                added: 'FIX.4.3',
                id: 167,
                description:
                    'It is recommended that CFICode be used instead of SecurityType for non-Fixed Income instruments.\n\nRequired for Fixed Income. Refer to Volume 7 - Fixed Income\n\nFutures and Options should be specified using the CFICode[461] field instead of SecurityType[167] (Refer to Volume 7 - Recommendations and Guidelines for Futures and Options Markets.)',
            },
            {
                added: 'FIX.4.4',
                id: 762,
            },
            {
                added: 'FIX.4.3',
                id: 200,
            },
            {
                updated: 'FIX.Latest',
                added: 'FIX.4.3',
                updatedEP: '271',
                id: 541,
                description:
                    'Specifies date of maturity (a full date). Note that standardized derivatives which are typically only referenced by month and year (e.g. S&P futures) may use MaturityMonthYear(200) and/or this field.\n\nWhen using MaturityMonthYear(200), it is recommended that markets and sell sides report the MaturityDate(541) on all outbound messages as a means of data enrichment.\n\nFor NDFs this represents the fixing date of the contract.',
            },
            {
                updated: 'FIX.5.0SP1',
                addedEP: '-1',
                added: 'FIX.4.4',
                updatedEP: '82',
                id: 1079,
            },
            {
                added: 'FIX.Latest',
                addedEP: '287',
                id: 2982,
            },
            {
                added: 'FIX.Latest',
                addedEP: '287',
                id: 2983,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 966,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1049,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 965,
            },
            {
                added: 'FIX.4.3',
                id: 224,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1449,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1450,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1451,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1452,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1457,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1458,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '119',
                id: 1739,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2210,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 1938,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 1939,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 1940,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2735,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1941,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1575,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1942,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1943,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1944,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1945,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1946,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1947,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1948,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1949,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1950,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 2879,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1951,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1952,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1953,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1954,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1955,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1956,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1957,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1958,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1959,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1960,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1577,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1580,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1581,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1678,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1697,
            },
            {
                added: 'FIX.4.3',
                id: 225,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 239,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 226,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 227,
            },
            {
                added: 'FIX.4.3',
                id: 228,
                description:
                    'For Fixed Income: Amortization Factor for deriving Current face from Original face for ABS or MBS securities, note the fraction may be greater than, equal to or less than 1. In TIPS securities this is the Inflation index.\n\nQty * Factor * Price = Gross Trade Amount\n\nFor Derivatives: Contract Value Factor by which price must be adjusted to determine the true nominal value of one futures/options contract.\n\n(Qty * Price) * Factor = Nominal Value',
            },
            {
                added: 'FIX.4.3',
                id: 255,
            },
            {
                added: 'FIX.4.3',
                id: 543,
            },
            {
                added: 'FIX.4.3',
                id: 470,
            },
            {
                added: 'FIX.4.3',
                id: 471,
            },
            {
                added: 'FIX.4.3',
                id: 472,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 240,
            },
            {
                added: 'FIX.4.3',
                id: 202,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2578,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2577,
            },
            {
                added: 'FIX.4.4',
                id: 947,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2904,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 967,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 968,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1698,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 1866,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2600,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2001,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2601,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '92',
                id: 1478,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '92',
                added: 'FIX.5.0SP1',
                updatedEP: '224',
                id: 1479,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '92',
                id: 1480,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '92',
                id: 1481,
            },
            {
                added: 'FIX.4.3',
                id: 206,
            },
            {
                added: 'FIX.4.3',
                id: 231,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '80',
                added: 'FIX.5.0SP1',
                updatedEP: '179',
                id: 1435,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 2353,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '80',
                added: 'FIX.5.0SP1',
                updatedEP: '179',
                id: 1439,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 969,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1146,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.4.4',
                updatedEP: '271',
                id: 996,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1147,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1716,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2905,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1191,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1192,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1717,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2906,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 1193,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2579,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1194,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '92',
                id: 1482,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '169',
                id: 1195,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '238',
                id: 2753,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1196,
            },
            {
                updated: 'FIX.5.0SP1',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '83',
                id: 1197,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2002,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2140,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '107',
                id: 1524,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2907,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1198,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1199,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1200,
            },
            {
                added: 'FIX.4.4',
                id: 201,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2681,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2685,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1244,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1242,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2575,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2574,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 997,
            },
            {
                added: 'FIX.4.3',
                id: 223,
            },
            {
                added: 'FIX.4.3',
                id: 207,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 970,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 971,
            },
            {
                added: 'FIX.4.3',
                id: 106,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 348,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 349,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2737,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2714,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2715,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2716,
            },
            {
                added: 'FIX.4.3',
                id: 107,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 350,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 351,
            },
            {
                added: 'FIX.4.4',
                id: 691,
            },
            {
                added: 'FIX.4.4',
                id: 667,
            },
            {
                added: 'FIX.4.4',
                id: 875,
            },
            {
                added: 'FIX.4.4',
                id: 876,
            },
            {
                added: 'FIX.4.4',
                id: 873,
            },
            {
                added: 'FIX.4.4',
                id: 874,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '120',
                id: 1687,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '130',
                id: 1787,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2141,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2142,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2143,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '238',
                id: 2752,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2144,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2145,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2576,
            },
            {
                added: 'FIX.Latest',
                addedEP: '276',
                id: 2962,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2602,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2603,
            },
        ],
        groupRef: [
            {
                added: 'FIX.4.4',
                id: 2071,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2226,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2241,
            },
            {
                added: 'FIX.4.4',
                id: 2070,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.4.4',
                updatedEP: '195',
                id: 1032,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '92',
                id: 2145,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4006,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4011,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4001,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4021,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4002,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4025,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4327,
            },
        ],
        componentRef: [
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '145',
                id: 1060,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4085,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4175,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4158,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4162,
            },
        ],
        description:
            'The Instrument component block contains all the fields commonly used to describe a security or instrument. Typically the data elements in this component block are considered the static data of a security, data that may be commonly found in a security master database. The Instrument component block can be used to describe any asset type supported by FIX.\n\n',
    },
    {
        name: 'InstrumentExtension',
        abbrName: 'InstrmtExt',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1004,
        fieldRef: [
            {
                added: 'FIX.4.4',
                id: 668,
            },
            {
                added: 'FIX.4.4',
                id: 869,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2736,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2738,
            },
        ],
        groupRef: [
            {
                added: 'FIX.4.4',
                id: 2074,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2262,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2263,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2264,
            },
        ],
        description:
            'The InstrumentExtension component block identifies additional security attributes that are more commonly found for Fixed Income securities.\n\n',
    },
    {
        name: 'InstrumentLeg',
        abbrName: 'Leg',
        added: 'FIX.4.3',
        category: 'Common',
        id: 1005,
        fieldRef: [
            {
                updated: 'FIX.Latest',
                added: 'FIX.4.3',
                updatedEP: '277',
                id: 600,
                description:
                    'Common, "human understood" representation of the security. SecurityID value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\n\nUse "[N/A]" for products which do not have a symbol.\n\nRequired if the InstrumentLeg component is marked as required where the component is used.',
            },
            {
                added: 'FIX.4.3',
                id: 601,
            },
            {
                added: 'FIX.4.3',
                id: 602,
            },
            {
                added: 'FIX.4.3',
                id: 603,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '131',
                id: 1788,
            },
            {
                added: 'FIX.4.3',
                id: 607,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '107',
                id: 1594,
            },
            {
                added: 'FIX.4.3',
                id: 608,
            },
            {
                added: 'FIX.Latest',
                addedEP: '266',
                id: 2893,
            },
            {
                added: 'FIX.4.3',
                id: 609,
            },
            {
                added: 'FIX.4.4',
                id: 764,
            },
            {
                added: 'FIX.4.3',
                id: 610,
            },
            {
                added: 'FIX.4.3',
                id: 611,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1212,
            },
            {
                added: 'FIX.Latest',
                addedEP: '287',
                id: 2986,
            },
            {
                added: 'FIX.Latest',
                addedEP: '287',
                id: 2987,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2146,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2147,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2148,
            },
            {
                added: 'FIX.4.3',
                id: 248,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2149,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2150,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2151,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2152,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2153,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2154,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2155,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2348,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 2067,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 2068,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 2069,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2739,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2070,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2156,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2157,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2158,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2159,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2160,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2161,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2162,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2163,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2164,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2165,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 2880,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2166,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2167,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2168,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2169,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2170,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2171,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2172,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2173,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2174,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2175,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2176,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2177,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2178,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2179,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2180,
            },
            {
                added: 'FIX.4.3',
                id: 249,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 250,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 251,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 252,
            },
            {
                added: 'FIX.4.3',
                id: 253,
            },
            {
                added: 'FIX.4.3',
                id: 257,
            },
            {
                added: 'FIX.4.3',
                id: 599,
            },
            {
                added: 'FIX.4.3',
                id: 596,
            },
            {
                added: 'FIX.4.3',
                id: 597,
            },
            {
                added: 'FIX.4.3',
                id: 598,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 254,
            },
            {
                added: 'FIX.4.3',
                id: 612,
            },
            {
                added: 'FIX.4.4',
                id: 942,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2908,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2181,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2182,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2183,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2184,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2604,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2185,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2605,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2186,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '224',
                id: 2187,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2188,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2189,
            },
            {
                added: 'FIX.4.3',
                id: 613,
            },
            {
                added: 'FIX.4.3',
                id: 614,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '80',
                added: 'FIX.5.0SP1',
                updatedEP: '179',
                id: 1436,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 2354,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '80',
                added: 'FIX.5.0SP1',
                updatedEP: '179',
                id: 1440,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2190,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2191,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 999,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1224,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1720,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2909,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1421,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1422,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1721,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2910,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2192,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1001,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1420,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2193,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2194,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '238',
                id: 2755,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2195,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2196,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2197,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2198,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '107',
                id: 1528,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2911,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2199,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2200,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2201,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2202,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2203,
            },
            {
                added: 'FIX.4.3',
                id: 615,
            },
            {
                added: 'FIX.4.3',
                id: 616,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2205,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2206,
            },
            {
                added: 'FIX.4.3',
                id: 617,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 618,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 619,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2740,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2717,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2718,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2719,
            },
            {
                added: 'FIX.4.3',
                id: 620,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 621,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 622,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2207,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2208,
            },
            {
                added: 'FIX.4.3',
                id: 623,
            },
            {
                added: 'FIX.4.3',
                id: 624,
            },
            {
                added: 'FIX.4.4',
                id: 556,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2898,
            },
            {
                added: 'FIX.4.4',
                id: 740,
            },
            {
                added: 'FIX.4.4',
                id: 739,
            },
            {
                added: 'FIX.4.4',
                id: 955,
            },
            {
                added: 'FIX.4.4',
                id: 956,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1358,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2682,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2686,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1017,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 566,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2209,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2211,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2212,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2213,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '238',
                id: 2754,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2214,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2215,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2606,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2607,
            },
        ],
        groupRef: [
            {
                added: 'FIX.4.4',
                id: 2072,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2232,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2242,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2231,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2239,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2236,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4031,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4046,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4187,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4231,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4190,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4226,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4337,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 2212,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4087,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4229,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4210,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4214,
            },
        ],
        description:
            'The InstrumentLeg component block, like the Instrument component block, contains all the fields commonly used to describe a security or instrument. In the case of the InstrumentLeg component block it describes a security used in multileg-oriented messages.\n\n',
    },
    {
        name: 'LegBenchmarkCurveData',
        abbrName: 'BnchmkCurve',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1006,
        fieldRef: [
            {
                added: 'FIX.4.4',
                id: 676,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2951,
            },
            {
                added: 'FIX.4.4',
                id: 677,
            },
            {
                added: 'FIX.4.4',
                id: 678,
            },
            {
                added: 'FIX.4.4',
                id: 679,
            },
            {
                added: 'FIX.4.4',
                id: 680,
            },
        ],
        description:
            'The LegBenchmarkCurveData is used to convey the benchmark information used for pricing in a multi-legged Fixed Income security.\n\n',
    },
    {
        name: 'OrderQtyData',
        abbrName: 'OrdQty',
        added: 'FIX.4.3',
        category: 'Common',
        id: 1011,
        fieldRef: [
            {
                added: 'FIX.4.3',
                id: 38,
            },
            {
                added: 'FIX.4.3',
                id: 152,
            },
            {
                added: 'FIX.4.3',
                id: 516,
            },
            {
                added: 'FIX.4.3',
                id: 468,
            },
            {
                added: 'FIX.4.3',
                id: 469,
            },
        ],
        description:
            'The OrderQtyData component block contains the fields commonly used for indicating the amount or quantity of an order. Note that when this component block is marked as "required" in a message either one of these three fields must be used to identify the amount: OrderQty, CashOrderQty or OrderPercent (in the case of CIV).\n\n',
    },
    {
        name: 'PegInstructions',
        abbrName: 'PegInstr',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1013,
        fieldRef: [
            {
                added: 'FIX.4.4',
                id: 211,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1094,
            },
            {
                added: 'FIX.4.4',
                id: 835,
            },
            {
                added: 'FIX.4.4',
                id: 836,
            },
            {
                added: 'FIX.4.4',
                id: 837,
            },
            {
                added: 'FIX.4.4',
                id: 838,
            },
            {
                added: 'FIX.4.4',
                id: 840,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1096,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1097,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1098,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1099,
            },
        ],
        description:
            'The Peg Instructions component block is used to tie the price of a security to a market event such as opening price, mid-price, best price. The Peg Instructions block may also be used to tie the price to the behavior of a related security.\n\n',
    },
    {
        name: 'SettlInstructionsData',
        abbrName: 'SetInstr',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1016,
        fieldRef: [
            {
                added: 'FIX.4.4',
                id: 172,
            },
            {
                added: 'FIX.4.4',
                id: 169,
            },
            {
                added: 'FIX.4.4',
                id: 170,
            },
            {
                added: 'FIX.4.4',
                id: 171,
                description:
                    'Identifier used within the StandInstDbType\n\nRequired if AllocSettlInstType = 3 (should not be populated otherwise)',
            },
        ],
        groupRef: [
            {
                added: 'FIX.4.4',
                id: 2075,
            },
        ],
        description:
            'The SettlInstructionsData component block is used to convey key information regarding standing settlement and delivery instructions. It also provides a reference to standing settlement details regarding the source, delivery instructions, and settlement parties\n\n',
    },
    {
        name: 'SpreadOrBenchmarkCurveData',
        abbrName: 'SprdBnchmkCurve',
        added: 'FIX.4.3',
        category: 'Common',
        id: 1018,
        fieldRef: [
            {
                added: 'FIX.4.3',
                id: 218,
            },
            {
                added: 'FIX.4.3',
                id: 220,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2950,
            },
            {
                added: 'FIX.4.3',
                id: 221,
            },
            {
                added: 'FIX.4.3',
                id: 222,
            },
            {
                added: 'FIX.4.4',
                id: 662,
            },
            {
                added: 'FIX.4.4',
                id: 663,
            },
            {
                added: 'FIX.4.4',
                id: 699,
            },
            {
                added: 'FIX.4.4',
                id: 761,
            },
        ],
        description:
            'The SpreadOrBenchmarkCurveData component block is primarily used for Fixed Income to convey spread to a benchmark security or curve.\n\n',
    },
    {
        name: 'UnderlyingInstrument',
        abbrName: 'Undly',
        added: 'FIX.4.3',
        category: 'Common',
        id: 1021,
        fieldRef: [
            {
                updated: 'FIX.Latest',
                added: 'FIX.4.3',
                updatedEP: '277',
                id: 311,
                description:
                    'Common, "human understood" representation of the security. SecurityID value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\n\nUse "[N/A]" for products which do not have a symbol.\n\nRequired if the UnderlyingInstrument component is marked as required where the component is used.',
            },
            {
                added: 'FIX.4.3',
                id: 312,
            },
            {
                added: 'FIX.4.3',
                id: 309,
            },
            {
                added: 'FIX.4.3',
                id: 305,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 2874,
            },
            {
                added: 'FIX.4.3',
                id: 462,
            },
            {
                added: 'FIX.4.3',
                id: 463,
            },
            {
                added: 'FIX.Latest',
                addedEP: '266',
                id: 2894,
            },
            {
                added: 'FIX.4.3',
                id: 310,
            },
            {
                added: 'FIX.4.4',
                id: 763,
            },
            {
                added: 'FIX.4.3',
                id: 313,
            },
            {
                added: 'FIX.4.3',
                id: 542,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1213,
            },
            {
                added: 'FIX.Latest',
                addedEP: '287',
                id: 2984,
            },
            {
                added: 'FIX.Latest',
                addedEP: '287',
                id: 2985,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '140',
                id: 1837,
            },
            {
                added: 'FIX.4.3',
                id: 241,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1453,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1454,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2614,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2615,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2921,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2616,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2617,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2619,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1455,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1456,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1459,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '83',
                id: 1460,
            },
            {
                added: 'FIX.4.3',
                id: 242,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 243,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 244,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 245,
            },
            {
                added: 'FIX.4.3',
                id: 246,
            },
            {
                added: 'FIX.4.3',
                id: 256,
            },
            {
                added: 'FIX.4.3',
                id: 595,
            },
            {
                added: 'FIX.4.3',
                id: 592,
            },
            {
                added: 'FIX.4.3',
                id: 593,
            },
            {
                added: 'FIX.4.3',
                id: 594,
            },
            {
                added: 'FIX.4.3',
                deprecated: 'FIX.4.4',
                id: 247,
            },
            {
                added: 'FIX.4.3',
                id: 316,
            },
            {
                added: 'FIX.4.4',
                id: 941,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2917,
            },
            {
                added: 'FIX.4.3',
                id: 317,
            },
            {
                added: 'FIX.4.3',
                id: 436,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '80',
                added: 'FIX.5.0SP1',
                updatedEP: '179',
                id: 1437,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 2363,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '80',
                added: 'FIX.5.0SP1',
                updatedEP: '179',
                id: 1441,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 998,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1423,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1718,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2918,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1424,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1425,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1719,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2919,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1000,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1419,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '107',
                id: 1526,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2920,
            },
            {
                added: 'FIX.4.3',
                id: 435,
            },
            {
                added: 'FIX.4.3',
                id: 308,
            },
            {
                added: 'FIX.4.3',
                id: 306,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 362,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 363,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2742,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2720,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2721,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2722,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2723,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '232',
                id: 2724,
            },
            {
                added: 'FIX.4.3',
                id: 307,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 364,
            },
            {
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.3',
                updatedEP: '232',
                id: 365,
            },
            {
                added: 'FIX.4.4',
                id: 877,
            },
            {
                added: 'FIX.4.4',
                id: 878,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 972,
            },
            {
                added: 'FIX.4.4',
                id: 318,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2916,
            },
            {
                added: 'FIX.4.4',
                id: 879,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nUnit amount of the underlying security (par, shares, currency, etc.)',
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 975,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 973,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 974,
            },
            {
                added: 'FIX.4.4',
                id: 810,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nIn a financing deal clean price (percent-of-par or per unit) of the underlying security or basket.',
            },
            {
                added: 'FIX.4.4',
                id: 882,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nIn a financing deal price (percent-of-par or per unit) of the underlying security or basket. "Dirty" means it includes accrued interest',
            },
            {
                added: 'FIX.4.4',
                id: 883,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nIn a financing deal price (percent-of-par or per unit) of the underlying security or basket at the end of the agreement.',
            },
            {
                added: 'FIX.4.4',
                id: 884,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nCurrency value attributed to this collateral at the start of the agreement',
            },
            {
                added: 'FIX.4.4',
                id: 885,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nCurrency value currently attributed to this collateral',
            },
            {
                added: 'FIX.4.4',
                id: 886,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nCurrency value attributed to this collateral at the end of the agreement',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '258',
                id: 2885,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '258',
                id: 2886,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1044,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1045,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1046,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1038,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1039,
            },
            {
                added: 'FIX.4.3',
                id: 315,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2683,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2687,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1988,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1989,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1990,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1991,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1992,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1993,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 2881,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1994,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1995,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1996,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1997,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2620,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2621,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1998,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 1999,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2000,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2003,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2004,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2005,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2006,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2284,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2285,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2286,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2287,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2288,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2007,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2008,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2009,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2010,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2011,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2012,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2491,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 2013,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 2014,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '235',
                id: 2015,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2744,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2016,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2289,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2017,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2018,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2019,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2020,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2021,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2022,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2290,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2622,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2291,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2623,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2292,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2023,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '224',
                id: 2024,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2025,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2026,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2027,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2028,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '169',
                id: 2029,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '238',
                id: 2757,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2030,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2031,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2293,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2294,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2032,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2033,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2034,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2035,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2036,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2037,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2038,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2039,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2040,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2041,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2042,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2043,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2044,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 41314,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 41315,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2295,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2296,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2297,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '238',
                id: 2756,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2298,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2299,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2624,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2625,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2626,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2627,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2628,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2629,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2630,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 2631,
            },
        ],
        groupRef: [
            {
                added: 'FIX.4.4',
                id: 2073,
            },
            {
                added: 'FIX.4.4',
                id: 1023,
                description:
                    'Specific to the <UnderlyingInstrument> (not in <Instrument>)\n\nInsert here the contents of the <UnderlyingStipulations> Component Block',
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1033,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2227,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2233,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 2243,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 2228,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4056,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4306,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4288,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4293,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4290,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4291,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4398,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 2213,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4125,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4278,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4268,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4261,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4414,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4396,
            },
        ],
        description:
            'The UnderlyingInstrument component block, like the Instrument component block, contains all the fields commonly used to describe a security or instrument. In the case of the UnderlyingInstrument component block it describes an instrument which underlies the primary instrument Refer to the Instrument component block comments as this component block mirrors Instrument, except for the noted fields.\n\n',
    },
    {
        name: 'YieldData',
        abbrName: 'Yield',
        added: 'FIX.4.3',
        category: 'Common',
        id: 1022,
        fieldRef: [
            {
                added: 'FIX.4.3',
                id: 235,
            },
            {
                added: 'FIX.4.3',
                id: 236,
            },
            {
                added: 'FIX.4.4',
                id: 701,
            },
            {
                added: 'FIX.4.4',
                id: 696,
            },
            {
                added: 'FIX.4.4',
                id: 697,
            },
            {
                added: 'FIX.4.4',
                id: 698,
            },
        ],
        description: 'The YieldData component block conveys yield information for a given Fixed Income security.\n\n',
    },
    {
        name: 'StandardHeader',
        abbrName: 'Hdr',
        updated: 'FIX.Latest',
        added: 'FIX.4.0',
        updatedEP: '271',
        category: 'Session',
        id: 1024,
        fieldRef: [
            {
                added: 'FIX.4.0',
                id: 8,
                presence: 'required',
            },
            {
                added: 'FIX.4.0',
                id: 9,
                presence: 'required',
            },
            {
                added: 'FIX.4.0',
                id: 35,
                presence: 'required',
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1128,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1156,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1129,
            },
            {
                added: 'FIX.4.0',
                id: 49,
                presence: 'required',
            },
            {
                added: 'FIX.4.0',
                id: 56,
                presence: 'required',
            },
            {
                added: 'FIX.4.0',
                id: 115,
            },
            {
                added: 'FIX.4.0',
                id: 128,
            },
            {
                deprecatedEP: '195',
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.0',
                updatedEP: '195',
                deprecated: 'FIX.5.0SP2',
                id: 90,
            },
            {
                deprecatedEP: '195',
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.0',
                updatedEP: '195',
                deprecated: 'FIX.5.0SP2',
                id: 91,
            },
            {
                added: 'FIX.4.0',
                id: 34,
                presence: 'required',
            },
            {
                added: 'FIX.4.0',
                id: 50,
            },
            {
                added: 'FIX.4.1',
                id: 142,
            },
            {
                added: 'FIX.4.0',
                id: 57,
            },
            {
                added: 'FIX.4.1',
                id: 143,
            },
            {
                added: 'FIX.4.0',
                id: 116,
            },
            {
                added: 'FIX.4.1',
                id: 144,
            },
            {
                added: 'FIX.4.0',
                id: 129,
            },
            {
                added: 'FIX.4.1',
                id: 145,
            },
            {
                added: 'FIX.4.0',
                id: 43,
            },
            {
                added: 'FIX.4.0',
                id: 97,
            },
            {
                added: 'FIX.4.0',
                id: 52,
                presence: 'required',
            },
            {
                added: 'FIX.4.0',
                id: 122,
            },
            {
                added: 'FIX.4.2',
                id: 212,
            },
            {
                added: 'FIX.4.2',
                id: 213,
                description:
                    'Can contain a XML formatted message block (e.g. FIXML). Always immediately follows XmlDataLen field. (Can be embedded within encrypted data section.)\n\nSee Volume 1: FIXML Support',
            },
            {
                added: 'FIX.4.2',
                id: 347,
            },
            {
                added: 'FIX.4.2',
                id: 369,
            },
        ],
        groupRef: [
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 2085,
            },
        ],
        description: 'The standard FIX message header\n\n',
    },
    {
        name: 'StandardTrailer',
        abbrName: 'Trlr',
        added: 'FIX.4.0',
        category: 'Session',
        id: 1025,
        fieldRef: [
            {
                deprecatedEP: '195',
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.0',
                updatedEP: '195',
                deprecated: 'FIX.5.0SP2',
                id: 93,
            },
            {
                deprecatedEP: '195',
                updated: 'FIX.5.0SP2',
                added: 'FIX.4.0',
                updatedEP: '195',
                deprecated: 'FIX.5.0SP2',
                id: 89,
            },
            {
                added: 'FIX.4.0',
                id: 10,
                presence: 'required',
            },
        ],
        description: 'The standard FIX message trailer\n\n',
    },
    {
        name: 'DisplayInstruction',
        abbrName: 'DsplyInstr',
        addedEP: '-1',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1029,
        fieldRef: [
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1138,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1082,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '115',
                id: 1608,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '253',
                id: 2828,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1083,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1084,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1085,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1086,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1087,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1088,
            },
        ],
        description:
            'The DisplayInstruction component block is used to convey instructions on how a reserved order is to be handled in terms of when and how much of the order quantity is to be displayed to the market.\n\n',
    },
    {
        name: 'TriggeringInstruction',
        abbrName: 'TrgrInstr',
        addedEP: '-1',
        added: 'FIX.4.4',
        category: 'Common',
        id: 1030,
        fieldRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1100,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1101,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '100',
                id: 1628,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1102,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1103,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1104,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1105,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1106,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1107,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1108,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1109,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1110,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1111,
            },
            {
                added: 'FIX.4.4',
                addedEP: '-1',
                id: 1112,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1113,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1114,
            },
        ],
        description:
            'The TriggeringInstruction component block specifies the conditions under which an order will be triggered by related market events as well as the behavior of the order in the market once it is triggered.\n\n',
    },
    {
        name: 'SecurityTradingRules',
        abbrName: 'SecTrdgRules',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 1058,
        componentRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2131,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2130,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2135,
            },
        ],
        description:
            "Ths SecurityTradingRules component block is used as part of security definition to specify the specific security's standard trading parameters such as trading session eligibility and other attributes of the security.\n\n",
    },
    {
        name: 'SecurityXML',
        abbrName: 'SecXML',
        updated: 'FIX.5.0SP2',
        addedEP: '-1',
        added: 'FIX.5.0',
        updatedEP: '145',
        category: 'Common',
        id: 1060,
        fieldRef: [
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '145',
                id: 1184,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '145',
                id: 1185,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '145',
                id: 1186,
            },
        ],
        description:
            'The SecurityXML component is used to provide a definition in an XML format for the instrument.\n\nSee "Specifying an FpML product specification from within the FIX Instrument Block" in Volume 1 of the FIX Specification for more information on using this component block with FpML as a guideline.',
    },
    {
        name: 'SecondaryPriceLimits',
        abbrName: 'PxLmts2',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 2121,
        fieldRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1305,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1221,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1230,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1240,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'PriceLimits',
        abbrName: 'PxLmts',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 2122,
        fieldRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1306,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1148,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1149,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1150,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'TradingSessionRules',
        abbrName: 'TrdgSesRules',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 2129,
        groupRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2128,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '223',
                id: 2127,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '223',
                id: 2126,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '223',
                id: 2253,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '223',
                id: 2125,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '223',
                id: 2123,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'BaseTradingRules',
        abbrName: 'BaseTrdgRules',
        updated: 'FIX.5.0SP2',
        addedEP: '-1',
        added: 'FIX.5.0',
        updatedEP: '195',
        category: 'Common',
        id: 2131,
        groupRef: [
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 2118,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2124,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2255,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2256,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2122,
            },
        ],
        fieldRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 827,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '130',
                added: 'FIX.5.0SP2',
                updatedEP: '195',
                id: 1786,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 562,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 1140,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 1143,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1144,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 1245,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2934,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 561,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 1377,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 1378,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '195',
                id: 423,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2557,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '195',
                id: 2559,
            },
        ],
        description:
            'Trading rules that are applicable to a market, market segment or individual security independent of a trading session.\n\n',
    },
    {
        name: 'DerivativeInstrument',
        abbrName: 'DerivInstrmt',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 2140,
        fieldRef: [
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '277',
                id: 1214,
                description:
                    'Common, "human understood" representation of the security. SecurityID value can be specified if no symbol exists (e.g. non-exchange traded Collective Investment Vehicles)\n\nUse "[N/A]" for products which do not have a symbol.\n\nRequired if DerivativeInstrument component is marked as required where the component is used.',
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1215,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1216,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1217,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1246,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1228,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1243,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1247,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1248,
            },
            {
                added: 'FIX.Latest',
                addedEP: '266',
                id: 2892,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1249,
                description:
                    'It is recommended that CFICode be used instead of SecurityType for non-Fixed Income instruments.\n\nRequired for Fixed Income. Refer to Volume 7 - Fixed Income\n\nFutures and Options should be specified using the CFICode[461] field instead of SecurityType[167] (Refer to Volume 7 - Recommendations and Guidelines for Futures and Options Markets.)',
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1250,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1251,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1252,
                description:
                    'Note that standardized derivatives which are typically only referenced by month and year (e.g. S and P futures).may use MaturityMonthYear and or this field.\n\nWhen using MaturityMonthYear, it is recommended that markets and sell sides report the MaturityDate on all outbound messages as a means of data enrichment.',
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1253,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1254,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1255,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1256,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1276,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1257,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1258,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1259,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1260,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1261,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1262,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2912,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1263,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1264,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1265,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1266,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '80',
                id: 1438,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '80',
                id: 1442,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1267,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1268,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1269,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1270,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1722,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2913,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1315,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1316,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '122',
                id: 1723,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2914,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1317,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1318,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1319,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '107',
                id: 1576,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2915,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1320,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1321,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1322,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1323,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2684,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '224',
                id: 2688,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1299,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1225,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1271,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1272,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1273,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1274,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1275,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1277,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1278,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1279,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1280,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1281,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1285,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2105,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2106,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2141,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1061,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'DerivativeSecurityDefinition',
        abbrName: 'DerivSecDef',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 2133,
        componentRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2140,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2136,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 2132,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '107',
                id: 2188,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'DerivativeSecurityXML',
        abbrName: 'SecXML',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 1061,
        fieldRef: [
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1282,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1283,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '-1',
                added: 'FIX.5.0',
                updatedEP: '271',
                id: 1284,
            },
        ],
        description: '\n\n',
    },
    {
        deprecatedEP: '187',
        name: 'UnderlyingLegInstrument',
        abbrName: 'Instrmt',
        updated: 'FIX.5.0SP1',
        addedEP: '-1',
        added: 'FIX.5.0',
        updatedEP: '97',
        category: 'TradeCapture',
        deprecated: 'FIX.5.0SP2',
        id: 2134,
        fieldRef: [
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1330,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1331,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1332,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1333,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1344,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1337,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1338,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1339,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1345,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1405,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1340,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1391,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1343,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1341,
            },
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 1392,
            },
        ],
        groupRef: [
            {
                deprecatedEP: '187',
                addedEP: '-1',
                added: 'FIX.5.0',
                deprecated: 'FIX.5.0SP2',
                id: 2108,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'ApplicationSequenceControl',
        abbrName: 'ApplSeqCtrl',
        addedEP: '-1',
        added: 'FIX.5.0',
        category: 'Common',
        id: 1057,
        fieldRef: [
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1180,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1181,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1350,
            },
            {
                added: 'FIX.5.0',
                addedEP: '-1',
                id: 1352,
            },
        ],
        description:
            'The ApplicationSequenceControl is used for application sequencing and recovery. Consisting of ApplSeqNum (1181), ApplID (1180), ApplLastSeqNum (1350), and ApplResendFlag (1352), FIX application messages that carries this component block will be able to use application level sequencing. ApplID, ApplSeqNum and ApplLastSeqNum fields identify the application id, application sequence number and the previous application sequence number (in case of intentional gaps) on each application message that carries this block.\n\n',
    },
    {
        name: 'TradeReportOrderDetail',
        abbrName: 'TrdRptOrdDetl',
        addedEP: '77',
        added: 'FIX.5.0SP1',
        category: 'TradeCapture',
        id: 2143,
        fieldRef: [
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 37,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 198,
            },
            {
                updated: 'FIX.5.0SP1',
                addedEP: '77',
                added: 'FIX.5.0SP1',
                updatedEP: '95',
                id: 11,
            },
            {
                updated: 'FIX.5.0SP1',
                addedEP: '77',
                added: 'FIX.5.0SP1',
                updatedEP: '95',
                id: 526,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 66,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1080,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1081,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1431,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '101',
                id: 1091,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 40,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 44,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 99,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 18,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 39,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 151,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 14,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 59,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 126,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '211',
                id: 2362,
            },
            {
                added: 'FIX.Latest',
                addedEP: '280',
                id: 2964,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '100',
                added: 'FIX.5.0SP2',
                updatedEP: '159',
                id: 1629,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '159',
                id: 1916,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 528,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 529,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '78',
                id: 775,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1432,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '222',
                id: 1724,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '228',
                id: 2704,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 821,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1093,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 483,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 586,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '240',
                id: 2766,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '259',
                id: 2270,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '99',
                id: 1064,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '222',
                id: 1073,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1011,
            },
            {
                added: 'FIX.5.0SP1',
                addedEP: '77',
                id: 1029,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'InstrumentScope',
        abbrName: 'InstrmtScope',
        updated: 'FIX.5.0SP2',
        addedEP: '105',
        added: 'FIX.5.0SP2',
        updatedEP: '106',
        category: 'Common',
        id: 2162,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1536,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1537,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1538,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1539,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1543,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1544,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1545,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1546,
            },
            {
                added: 'FIX.Latest',
                addedEP: '266',
                id: 2895,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1547,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1548,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1549,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1550,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1551,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1552,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1553,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1554,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '105',
                added: 'FIX.5.0SP2',
                updatedEP: '182',
                id: 1555,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1616,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1556,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1620,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1621,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 1557,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '105',
                id: 2163,
            },
        ],
        description: 'Used to specify the instrument\n\n',
    },
    {
        name: 'ThrottleResponse',
        abbrName: 'ThrttlRsp',
        addedEP: '116',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 1069,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '116',
                id: 1685,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '116',
                id: 1609,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '116',
                id: 1686,
            },
        ],
        description: '\n\n',
    },
    {
        name: 'LegSecurityXML',
        abbrName: 'SecXML',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 2212,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 1871,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 1872,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 1873,
            },
        ],
        description:
            'The LegSecurityXML component is used to provide a definition in an XML format for the leg instrument.\n\nSee "Specifying an FpML product specification from within the FIX Instrument Block" in Volume 1 of the FIX Specification for more information on using this component block with FpML as a guideline.',
    },
    {
        name: 'UnderlyingSecurityXML',
        abbrName: 'SecXML',
        addedEP: '145',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 2213,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 1874,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 1875,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '145',
                id: 1876,
            },
        ],
        description:
            'The UnderlyingSecurityXML component is used to provide a definition in an XML format for the underlying instrument.\n\nSee "Specifying an FpML product specification from within the FIX Instrument Block" in Volume 1 of the FIX Specification for more information on using this component block with FpML as a guideline.',
    },
    {
        name: 'LegPaymentStream',
        abbrName: 'PmtStrm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4035,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40279,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40280,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40281,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42399,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40282,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40283,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 43108,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40284,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40285,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40286,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40287,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40288,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42400,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42401,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42402,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42403,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40289,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40290,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40291,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41549,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41550,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41551,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41552,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41553,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41554,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41555,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42404,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4036,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4037,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4038,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4039,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4342,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4339,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4040,
            },
        ],
        description:
            'The LegPaymentStream component is a subcomponent of the LegStreamGrp used to detail the attributes of a payment stream in a swap.\n\n',
    },
    {
        name: 'LegPaymentStreamFixedRate',
        abbrName: 'Fixed',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4038,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40326,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40327,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40328,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41556,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41557,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40329,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40330,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41558,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41559,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41560,
            },
        ],
        description:
            'LegPaymentStreamFixedRate is a subcomponent of the LegPaymentStream component used to report the fixed rate or fixed payment amount of the payment stream.\n\n',
    },
    {
        name: 'LegPaymentStreamFloatingRate',
        abbrName: 'Float',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '271',
        category: 'Common',
        id: 4039,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40331,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40332,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43088,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43089,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40333,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40334,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43116,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43117,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43118,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43119,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 41563,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 41564,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41565,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41566,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41567,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41568,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41569,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41570,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41571,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40335,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40336,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41572,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41573,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41574,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41575,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40337,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40338,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40339,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40340,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40341,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40342,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40343,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40344,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40345,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41576,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41577,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40346,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40347,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40348,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40349,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41578,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41579,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42462,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42463,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42464,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41580,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41581,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42465,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41582,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41583,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41584,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41585,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41586,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40350,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40351,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40352,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40353,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40354,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40355,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40356,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40357,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40358,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42466,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42467,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42468,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42469,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42470,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42471,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42472,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42473,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42474,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42475,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42476,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42477,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42478,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42479,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42480,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42481,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4222,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4225,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4224,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4355,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4347,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4333,
            },
        ],
        description:
            'LegPaymentStreamFloatingRate is a subcomponent of the LegPaymentStream component used to report the floating rate attributes of the payment stream.\n\nNote that if the floating rate index or the rate calculation goes negative for a calculation period and LegPaymentStreamNegativeRateTreatment(40349)=1 (Negative interest rate method) the Receiver pays the Payer the absolute floating rate, i.e. the Receiver pays the cash flow amount to the Payer.\n\nThe Calculation Lag Interval (LegPaymentStreamCalculationLagPeriod(41578) and LegPaymentStreamCalculationLagUnit(41579)) and the First Observation Offset Duration (LegPaymentStreamFirstObservationOffsetPeriod(41580) and LegPaymentStreamFirstObservationOffsetUnit(41581)) are used together. If the First Observation Offset Duration is specified, the observation starts the Fixing Lag Interval prior to each calculation. If the First Observation Offset Duration is not specified, the observation starts immediately preceding each calculation.',
    },
    {
        name: 'LegPaymentStreamNonDeliverableSettlTerms',
        abbrName: 'NonDlvrblTrms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4040,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40359,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40360,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40362,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40363,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40364,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40365,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4090,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4041,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4080,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4042,
            },
        ],
        description:
            'LegPaymentStreamNonDeliverableSettl is a subcomponent of the LegPaymentStream component used to specify the non-deliverable settlement terms of the payment stream.\n\n',
    },
    {
        name: 'LegPaymentStreamPaymentDates',
        abbrName: 'PmtDts',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4036,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40292,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40294,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40295,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40296,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40297,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40298,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40299,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40300,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40301,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40302,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41592,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4091,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4223,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4345,
            },
        ],
        description:
            'The LegPaymentStreamPaymentDates component is a subcomponent of the LegPaymentStream component used to specify the payment dates of the stream.\n\nFor equity return swaps this component is used to specify the interim price payment dates and the LegPaymentStreamFinalPricePaymentDate component is used to specify the final price payment date.',
    },
    {
        name: 'LegPaymentStreamResetDates',
        abbrName: 'ResetDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4037,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40303,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40304,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40306,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40307,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40308,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40309,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40310,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40312,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40313,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40314,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40315,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40316,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40317,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40319,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40320,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40321,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40322,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40323,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40324,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40325,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4092,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4093,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4094,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4346,
            },
        ],
        description:
            'The LegPaymentStreamResetDates component is a subcomponent of the LegPaymentStream component used to specify the floating rate reset dates of the stream.\n\n',
    },
    {
        name: 'LegProvisionCashSettlPaymentDates',
        abbrName: 'CashSettlPmtDts',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4052,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40516,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40518,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40519,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40520,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40521,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40522,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40523,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4095,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4047,
            },
        ],
        description:
            'The LegProvisionCashSettlPaymentDates component is a sub-component within the LegProvisionGrp component used to report the cash settlement payment dates defined in the provision.\n\n',
    },
    {
        name: 'LegProvisionCashSettlValueDates',
        abbrName: 'CashSettlValDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4053,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40524,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40525,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40526,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40528,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40529,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40530,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40531,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40532,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4096,
            },
        ],
        description:
            'The LegProvisionCashSettlValueDates component is a subcomponent within the LegProvisionGrp component used to report the cash settlement value date and time defined in the provision.\n\n',
    },
    {
        name: 'LegProvisionOptionExerciseDates',
        abbrName: 'OptExerDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4048,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40476,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40478,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40479,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40480,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40481,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40482,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40483,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40484,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40485,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40486,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40487,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40488,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40489,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40490,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40491,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40492,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40493,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40494,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4097,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4049,
            },
        ],
        description:
            'The LegProvisionOptionExerciseDates is a subcomponent within the LegProvisionGrp component used to report the option exercise dates and times defined in the provision.\n\n',
    },
    {
        name: 'LegProvisionOptionExpirationDate',
        abbrName: 'OptExpDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4050,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40498,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40499,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40501,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40502,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40503,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40504,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40505,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40506,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40507,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4098,
            },
        ],
        description:
            'The LegProvisionOptionExerciseDate is a subcomponent within the LegProvisionGrp component used to report the option expiration date and times defined in the provision.\n\n',
    },
    {
        name: 'LegProvisionOptionRelevantUnderlyingDate',
        abbrName: 'OptRelvntUndlyDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4051,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40508,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40509,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40511,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40512,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40513,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40514,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40515,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4099,
            },
        ],
        description:
            'The LegProvisionOptionRelevantUnderlyingDate is a subcomponent within the LegProvisionGrp component used to report the option relevant underlyingdate defined in the provision.\n\n',
    },
    {
        name: 'LegStreamCalculationPeriodDates',
        abbrName: 'CalcDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4034,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41641,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41642,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '169',
                id: 40265,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40267,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40268,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40270,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40271,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40272,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40273,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40274,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40275,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40276,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41643,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41644,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41645,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4101,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4235,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4102,
            },
        ],
        description:
            'LegStreamCalculationPeriodDates is a subcomponent of the LegStreamGrp component used to specify the calculation period dates of the stream.\n\n',
    },
    {
        name: 'LegStreamEffectiveDate',
        abbrName: 'EfctvDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4032,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40249,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40250,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40252,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40253,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40254,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40255,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40256,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4103,
            },
        ],
        description:
            'LegStreamEffectivedDate is a subcomponent of the LegStreamGrp component used to specify the effective date of the stream.\n\n',
    },
    {
        name: 'LegStreamTerminationDate',
        abbrName: 'TrmtnDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4033,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40257,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40258,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40260,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40261,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40262,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40263,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40264,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4104,
            },
        ],
        description:
            'LegStreamTerminationDate is a subcomponent of the LegStreamGrp component used to specify the termination date of the stream.\n\n',
    },
    {
        name: 'PaymentStream',
        abbrName: 'PmtStrm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4070,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40738,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40739,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40740,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42600,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40741,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40742,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 43106,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40743,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40744,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40745,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40746,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40747,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42601,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42602,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42603,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42604,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40748,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40749,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40750,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41180,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41181,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41182,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41183,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41184,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41185,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41186,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42605,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4071,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4072,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4073,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4074,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4367,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4364,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4075,
            },
        ],
        description:
            'The PaymentStream component is a subcomponent of the Stream used to detail the attributes of a payment stream in a swap.\n\n',
    },
    {
        name: 'PaymentStreamFixedRate',
        abbrName: 'Fixed',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4073,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40784,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40785,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40786,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41187,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41188,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40787,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40788,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41189,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41190,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41191,
            },
        ],
        description:
            'PaymentStreamFixedRate is a subcomponent of the PaymentStream component used to report the fixed rate or fixed payment amount of the stream.\n\n',
    },
    {
        name: 'PaymentStreamFloatingRate',
        abbrName: 'Float',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '271',
        category: 'Common',
        id: 4074,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40789,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40790,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43090,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43091,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40791,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40792,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43112,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43113,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43114,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43115,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 41194,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 41195,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41196,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41197,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41198,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41199,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41200,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41201,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41202,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40793,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40794,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41203,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41204,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41205,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41206,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40795,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40796,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40797,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40798,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40799,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40800,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40801,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40802,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40803,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41207,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41208,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40804,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40805,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40806,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40807,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41209,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41210,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42663,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42664,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42665,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41211,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41212,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42666,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41213,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41214,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41215,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41216,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41217,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40808,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40809,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40810,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40811,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40812,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40813,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40814,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40815,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40816,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42667,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42668,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42669,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42670,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42671,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42672,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42673,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42674,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42675,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42676,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42677,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42678,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42679,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42680,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42681,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42682,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4170,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4173,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4172,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4380,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4373,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4323,
            },
        ],
        description:
            'PaymentStreamFloatingRate is a subcomponent of the PaymentStream component used to report the floating rate attributes of the stream.\n\nNote that if the floating rate index or the rate calculation goes negative for a calculation period and PaymentStreamNegativeRateTreatment(40807)=1 (Negative interest rate method) the Receiver pays the Payer the absolute floating rate, i.e. the Receiver pays the cash flow amount to the Payer.\n\nThe Calculation Lag Interval (PaymentStreamCalculationLagPeriod(41209) and PaymentStreamCalculationLagUnit(41210)) and the First Observation Offset Duration (PaymentStreamFirstObservationOffsetPeriod(41211) and PaymentStreamFirstObservationOffsetUnit(41212)) are used together. If the First Observation Offset Duration is specified, the observation starts the Fixing Lag Interval prior to each calculation. If the First Observation Offset Duration is not specified, the observation starts immediately preceding each calculation.',
    },
    {
        name: 'PaymentStreamNonDeliverableSettlTerms',
        abbrName: 'NonDlvrblTrms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4075,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40817,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40818,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40820,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40821,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40822,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40823,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4108,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4076,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4010,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4137,
            },
        ],
        description:
            'PaymentStreamNonDeliverableSettlTerms is a subcomponent of the PaymentStream component used to specify the non-deliverable settlement terms of the payment stream.\n\n',
    },
    {
        name: 'PaymentStreamPaymentDates',
        abbrName: 'PmtDts',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4071,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40751,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40753,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40754,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40755,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40756,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40757,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40758,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40759,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40760,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40920,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41223,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4109,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4171,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4370,
            },
        ],
        description:
            'PaymentStreamPaymentDates is a subcomponent of the PaymentStream component used to specify the payment dates of the stream.\n\nFor equity return swaps this component is used to specify the interim price payment dates and the PaymentStreamFinalPricePaymentDate component is used to specify the final price payment date.',
    },
    {
        name: 'PaymentStreamResetDates',
        abbrName: 'ResetDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4072,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40761,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40762,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40764,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40765,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40766,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40767,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40768,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40770,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40771,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40772,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40773,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40774,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40775,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40777,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40778,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40779,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40780,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40781,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40782,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40783,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4110,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4111,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4112,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4371,
            },
        ],
        description:
            'PaymentStreamResetDates is a subcomponent of the PaymentStream component used to specify the floating rate reset dates of the stream.\n\n',
    },
    {
        name: 'ProvisionCashSettlPaymentDates',
        abbrName: 'CashSettlPmtDts',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4017,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40163,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40165,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40166,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40167,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40168,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40169,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40170,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4114,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4018,
            },
        ],
        description:
            'The ProvisionCashSettlPaymentDates component is a sub-component within the ProvisionGrp component used to report the cash settlement payment dates defined in the provision.\n\n',
    },
    {
        name: 'ProvisionCashSettlValueDates',
        abbrName: 'CashSettlValDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4012,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40114,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40115,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40116,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40118,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40119,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40120,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40121,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40122,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4115,
            },
        ],
        description:
            'The ProvisionCashSettlValueDates component is a subcomponent within the ProvisionGrp component used to report the cash settlement value date and time defined in the provision.\n\n',
    },
    {
        name: 'ProvisionOptionExerciseDates',
        abbrName: 'OptExerDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4013,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40123,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40125,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40126,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40127,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40128,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40129,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40130,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40131,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40132,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40133,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40134,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40135,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40136,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40137,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40138,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40139,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40140,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40141,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4116,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4014,
            },
        ],
        description:
            'The ProvisionOptionExerciseDates is a subcomponent within the ProvisionGrp component used to report the option exercise dates and times defined in the provision.\n\n',
    },
    {
        name: 'ProvisionOptionExpirationDate',
        abbrName: 'OptExpDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4015,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40145,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40146,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40148,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40149,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40150,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40151,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40152,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40153,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40154,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4117,
            },
        ],
        description:
            'The ProvisionOptionExerciseDate is a subcomponent within the ProvisionGrp component used to report the option expiration date and times defined in the provision.\n\n',
    },
    {
        name: 'ProvisionOptionRelevantUnderlyingDate',
        abbrName: 'OptRelvntUndlyDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4016,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40155,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40156,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40158,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40159,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40160,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40161,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40162,
            },
        ],
        groupRef: [
            {
                updated: 'FIX.Latest',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '282',
                id: 4118,
            },
        ],
        description:
            'The ProvisionOptionRelevantUnderlyingDate is a subcomponent within the ProvisionGrp component used to report the option relevant underlying date defined in the provision.\n\n',
    },
    {
        name: 'StreamCalculationPeriodDates',
        abbrName: 'CalcDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4009,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41244,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41245,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '169',
                id: 40073,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40075,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40076,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40078,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40079,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40080,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40081,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40082,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40083,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40084,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41246,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41247,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41248,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4120,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4177,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4121,
            },
        ],
        description:
            'StreamCalculationPeriodDates is a subcomponent of the StreamGrp component used to specify the calculation period dates of the stream.\n\n',
    },
    {
        name: 'StreamEffectiveDate',
        abbrName: 'EfctvDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4081,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40907,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40908,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40910,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40911,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40912,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40913,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40914,
            },
        ],
        groupRef: [
            {
                updated: 'FIX.Latest',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 4122,
            },
        ],
        description:
            'StreamEffectivedDate is a subcomponent of the StreamGrp component used to specify the effective date of the stream.\n\n',
    },
    {
        name: 'StreamTerminationDate',
        abbrName: 'TrmtnDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4008,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40065,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40066,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40068,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40069,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40070,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40071,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40072,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4123,
            },
        ],
        description:
            'StreamTerminationDate is a subcomponent of the StreamGrp component used to specify the termination date of the stream.\n\n',
    },
    {
        name: 'UnderlyingPaymentStream',
        abbrName: 'PmtStrm',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4059,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40568,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40569,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40570,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42895,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40571,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40572,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '254',
                id: 43107,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40573,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40574,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40575,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40576,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40577,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42896,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42897,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42898,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42899,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40578,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40579,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40580,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41897,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41898,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41899,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41900,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41901,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41902,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41903,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42900,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4060,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4061,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4062,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4063,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4403,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4400,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4064,
            },
        ],
        description:
            'The UnderlyingPaymentStream component is a subcomponent of the UnderlyingStream used to detail the attributes of a payment stream in a swap.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamFixedRate',
        abbrName: 'Fixed',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4062,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40615,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40616,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40617,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41904,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41905,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40618,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40619,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41906,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41907,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41908,
            },
        ],
        description:
            'UnderlyingPaymentStreamFixedRate is a subcomponent of the UnderlyingPaymentStream component used to report the fixed rate or fixed payment amount of the stream.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamFloatingRate',
        abbrName: 'Float',
        updated: 'FIX.Latest',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '271',
        category: 'Common',
        id: 4063,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40620,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40621,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43092,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43093,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40622,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40623,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43120,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43121,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43122,
            },
            {
                added: 'FIX.Latest',
                addedEP: '271',
                id: 43123,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 41911,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '169',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 41912,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41913,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41914,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41915,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41916,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41917,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41918,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41919,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40624,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40625,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41920,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41921,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41922,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41923,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40626,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40627,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40628,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40629,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40630,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40631,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40632,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40633,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40634,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41924,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41925,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40635,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40636,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40637,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40638,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41926,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41927,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42958,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42959,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42960,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41928,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41929,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42961,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41930,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41931,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41932,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41933,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41934,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40639,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40640,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40641,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40642,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40643,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40644,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40645,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40646,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40647,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42962,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42963,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42964,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42965,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42966,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42967,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42968,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42969,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42970,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42971,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42972,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42973,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42974,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42975,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42976,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42977,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4273,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4276,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4275,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4418,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4408,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4392,
            },
        ],
        description:
            'UnderlyingPaymentStreamFloatingRate is a subcomponent of the UnderlyingPaymentStream component used to report the floating rate attributes of the stream.\n\nNote that if the floating rate index or the rate calculation goes negative for a calculation period and UnderlyingPaymentStreamNegativeRateTreatment(40638)=1 (Negative interest rate method) the Receiver pays the Payer the absolute floating rate, i.e. the Receiver pays the cash flow amount to the Payer.\n\nThe Calculation Lag Interval (UnderlyingPaymentStreamCalculationLagPeriod(41926) and UnderlyingPaymentStreamCalculationLagUnit(41927)) and the First Observation Offset Duration (UnderlyingPaymentStreamFirstObservationOffsetPeriod(41928) and UnderlyingPaymentStreamFirstObservationOffsetUnit(41929)) are used together. If the First Observation Offset Duration is specified, the observation starts the Fixing Lag Interval prior to each calculation. If the First Observation Offset Duration is not specified, the observation starts immediately preceding each calculation.',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableSettlTerms',
        abbrName: 'NonDlvrblTrms',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4064,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40648,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40649,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40651,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40652,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40653,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40654,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4128,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4065,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4066,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4139,
            },
        ],
        description:
            'UnderlyingPaymentStreamNonDeliverableSettlTerms is a subcomponent of the UnderlyingPaymentStream component used to specify the non-deliverable settlement terms of the stream.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamPaymentDates',
        abbrName: 'PmtDts',
        updated: 'FIX.5.0SP2',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4060,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40581,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40583,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40584,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40585,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40586,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40587,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40588,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40589,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40590,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40591,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41940,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4129,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4274,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4406,
            },
        ],
        description:
            'UnderlyingPaymentStreamPaymentDates is a subcomponent of the UnderlyingPaymentStream component used to specify the payment dates of the stream.\n\nFor equity return swaps this component is used to specify the interim price payment dates and the UnderlyingPaymentStreamFinalPricePaymentDate component is used to specify the final price payment date.',
    },
    {
        name: 'UnderlyingPaymentStreamResetDates',
        abbrName: 'ResetDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4061,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40592,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40593,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40595,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40596,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40597,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40598,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40599,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40601,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40602,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40603,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40604,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40605,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40606,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40608,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40609,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40610,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40611,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40612,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '208',
                id: 40613,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40614,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4130,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4131,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4132,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4407,
            },
        ],
        description:
            'UnderlyingPaymentStreamResetDates is a subcomponent of the UnderlyingPaymentStream component used to specify the floating rate reset dates of the stream.\n\n',
    },
    {
        name: 'UnderlyingStreamCalculationPeriodDates',
        abbrName: 'CalcDts',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4058,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41957,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41958,
            },
            {
                updated: 'FIX.5.0SP2',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '169',
                id: 40556,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40558,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40559,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40561,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40562,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40563,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40564,
            },
            {
                updated: 'FIX.Latest',
                addedEP: '161',
                added: 'FIX.5.0SP2',
                updatedEP: '271',
                id: 40565,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40566,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40567,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41959,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41960,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41961,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4133,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4279,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4134,
            },
        ],
        description:
            'UnderlyingStreamCalculationPeriodDates is a subcomponent of the UnderlyingStreamGrp component used to specify the calculation period dates of the stream.\n\n',
    },
    {
        name: 'UnderlyingStreamEffectiveDate',
        abbrName: 'EfctvDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4007,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40057,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40058,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40060,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40061,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40062,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40063,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40064,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4135,
            },
        ],
        description:
            'UnderlyingStreamEffectivedDate is a subcomponent of the UnderlyingStreamGrp component used to specify the effective date of the stream.\n\n',
    },
    {
        name: 'UnderlyingStreamTerminationDate',
        abbrName: 'TrmtnDt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4057,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40548,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40549,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40551,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40552,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40553,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40554,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40555,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4136,
            },
        ],
        description:
            'UnderlyingStreamTerminationDate is a subcomponent of the UnderlyingStreamGrp component used to specify the termination date of the stream.\n\n',
    },
    {
        name: 'DateAdjustment',
        abbrName: 'DtAdjmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4085,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40921,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40922,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4084,
            },
        ],
        description:
            'DateAdjustment is a subcomponent in the Instrument component. It is used to specify date adjustment parameters and rules. The date adjustments specified here applies to all adjustable dates for the instrument, unless specifically overridden in the respective specified components elsewhere.\n\n',
    },
    {
        name: 'LegDateAdjustment',
        abbrName: 'DtAdjmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4087,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40925,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40926,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4086,
            },
        ],
        description:
            'LegDateAdjustment is a subcomponent within the InstrumentLeg component. It is used to specify date adjustment parameters and rules. The date adjustments specified here applies to all adjustable dates for the instrument leg, unless specifically overridden elsewhere in the respective specified components further within the InstrumentLeg component.\n\n',
    },
    {
        name: 'UnderlyingDateAdjustment',
        abbrName: 'DtAdjmt',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4125,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40964,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40965,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 4124,
            },
        ],
        description:
            'UnderlyingDateAdjustment is a subcomponent within the UnderlyingInstrument component. It is used to specify date adjustment parameters and rules. The date adjustments specified here applies to all adjustable dates for the underlying instrument, unless specifically overridden in the respective specified components further within the UnderlyingInstrument component.\n\n',
    },
    {
        name: 'LegPaymentStreamNonDeliverableSettlRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4042,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40087,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40228,
            },
        ],
        description:
            'LegPaymentStreamNonDeliverableSettlRateSource is a subcomponent of the LegPaymentStreamNonDeliverableSettlTerms component used to specify the rate source in the event of payment non-delivery.\n\n',
    },
    {
        name: 'LegSettlRateFallbackRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4082,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40366,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40370,
            },
        ],
        description:
            'LegSettlRateFallbackRateSource is a subcomponent of the LegSettlRateDisruptionFallbackGrp component used to specify the rate source in the event of rate disruption fallback.\n\n',
    },
    {
        name: 'PaymentStreamNonDeliverableSettlRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4137,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40371,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40372,
            },
        ],
        description:
            'PaymentStreamNonDeliverableSettlRateSource is a subcomponent of the PaymentStreamNonDeliverableSettlTerms component used to specify the rate source in the event of payment non-delivery.\n\n',
    },
    {
        name: 'SettlRateFallbackRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4138,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40373,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40655,
            },
        ],
        description:
            'SettlRateFallbackRateSource is a subcomponent of the SettlRateDisruptionFallbackGrp component used to specify the rate source in the event of rate disruption fallback.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamNonDeliverableSettlRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4139,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40661,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40824,
            },
        ],
        description:
            'UnderlyingPaymentStreamNonDeliverableSettlRateSource is a subcomponent of the UnderlyingPaymentStreamNonDeliverableSettlTerms component used to specify the rate source in the event of payment non-delivery.\n\n',
    },
    {
        name: 'UnderlyingSettlRateFallbackRateSource',
        abbrName: 'RtSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4140,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40904,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40915,
            },
        ],
        description:
            'UnderlyingSettlRateFallbackRateSource is a subcomponent of the UnderlyingSettlRateDisruptionFallbackGrp component used to specify the rate source in the event of rate disruption fallback.\n\n',
    },
    {
        name: 'ProvisionCashSettlQuoteSource',
        abbrName: 'CashSettlQteSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4201,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40112,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 41406,
            },
        ],
        description:
            'The ProvisionCashSettlQuoteSource is a subcomponent of the ProvisionGrp component used to specify the reference source for currency or rate quote for cash settlement purposes.\n\n',
    },
    {
        name: 'LegProvisionCashSettlQuoteSource',
        abbrName: 'CashSettlQteSrc',
        addedEP: '161',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4202,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 40470,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '161',
                id: 41407,
            },
        ],
        description:
            'The LegProvisionCashSettlQuoteSource is a subcomponent of the LEgProvisionGrp component used to specify the reference source for currency or rate quote for cash settlement purposes.\n\n',
    },
    {
        name: 'ComplexEventRelativeDate',
        abbrName: 'ReltvDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4149,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41020,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41021,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41022,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41023,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41024,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41025,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41026,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41027,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41028,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4148,
            },
        ],
        description:
            'The ComplexEventRelativeDate is a subcomponent of ComplexEvents for specifying the event date and time for an FX or Calendar Spread option or the payout date for a Barrier or Knock option.\n\n',
    },
    {
        name: 'DeliveryStream',
        abbrName: 'DlvryStrm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4155,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41058,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41059,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41060,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41061,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41062,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 42192,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 42193,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41063,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41064,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41065,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41066,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41067,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41218,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41068,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41069,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41070,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41071,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41072,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41073,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41074,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41075,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41076,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41077,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41078,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41079,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41080,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43094,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4157,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4156,
            },
        ],
        description:
            'The DeliveryStream component is used to optionally specify the attributes of a physical delivery stream in a swap.\n\n',
    },
    {
        name: 'MarketDisruption',
        abbrName: 'MktDsrptn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4158,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41087,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41088,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41089,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41090,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41091,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4159,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4160,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4161,
            },
        ],
        description:
            'The MarketDisruption component is a subcomponent of the Instrument used to specify the market disruption provisions of the swap.\n\n',
    },
    {
        name: 'OptionExercise',
        abbrName: 'OptExer',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '211',
        category: 'Common',
        id: 4162,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41106,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41107,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41108,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41109,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41110,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41111,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41112,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41113,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41114,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41115,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42590,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4386,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4164,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4167,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4362,
            },
        ],
        description:
            'The OptionExercise component is a subcomponent of the Instrument component used to specify option exercise provisions. Its purpose is to identify the opportunities and conditions for exercise, e.g. the schedule of dates on which exercise is allowed. The embedded OptionExerciseExpiration component is used to terminate the opportunity for exercise.\n\n',
    },
    {
        name: 'OptionExerciseDates',
        abbrName: 'Dts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4164,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41118,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41119,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41120,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41121,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41122,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41123,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41124,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41125,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41126,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41127,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41128,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41129,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41130,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41131,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41132,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41133,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41134,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41135,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41136,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4163,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4165,
            },
        ],
        description:
            'The OptionExerciseDate component is a subcomponent of the OptionExercise component used to specify option exercise dates.\n\n',
    },
    {
        name: 'OptionExerciseExpiration',
        abbrName: 'Exp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '211',
        category: 'Common',
        id: 4167,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41142,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41143,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41144,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41145,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41146,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41147,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41148,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41149,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41150,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41151,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4166,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4168,
            },
        ],
        description:
            'The OptionExerciseExpiration component is a subcomponent of the OptionExercise component used to specify option exercise expiration dates and times. The purpose of OptionExercise is to identify the scheduled opportunities for exercise. OptionExerciseExpiration identifies the end of the schedule.\n\n',
    },
    {
        name: 'PricingDateTime',
        abbrName: 'PxngDtTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4175,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41232,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41233,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41234,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41235,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41236,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4174,
            },
        ],
        description:
            'The PricingDateTime component is a subcomponent of Instrument used to specify an adjusted or unadjusted pricing or fixing date and optionally the time, e.g. for a commodity or FX forward trade.\n\n',
    },
    {
        name: 'StreamCommodity',
        abbrName: 'Cmdty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4179,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41251,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41252,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41253,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41254,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41255,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41256,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41257,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '193',
                id: 42587,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41258,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41259,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41260,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41261,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41262,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41263,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41264,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41265,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41266,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41267,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41268,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41269,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41270,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41271,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41272,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41273,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41274,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41275,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41276,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4180,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4176,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4181,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4178,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4184,
            },
        ],
        description:
            'StreamCommodity is a subcomponent of the Stream component used to identify and describe the underlying commodity.\n\n',
    },
    {
        name: 'LegComplexEventRelativeDate',
        abbrName: 'ReltvDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4198,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41389,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41390,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41391,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41392,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41393,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41394,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41395,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41396,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41397,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4197,
            },
        ],
        description:
            'LegComplexEventRelativeDate is a subcomponent of LegComplexEvents for specifying the event date and time for an FX or Calendar Spread option or the payout date for a Barrier or Knock option.\n\n',
    },
    {
        name: 'LegDeliveryStream',
        abbrName: 'DlvryStrm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4206,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41429,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41430,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41431,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41432,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41433,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 42194,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 42195,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41434,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41435,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41436,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41437,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41438,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41219,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41439,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41440,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41441,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41442,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41443,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41444,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41445,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41446,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41447,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41448,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41449,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41450,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41451,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43095,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4209,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4208,
            },
        ],
        description:
            'The LegDeliveryStream component is a subcomponent of the LegStream used to detail the attributes of a physical delivery stream in a swap.\n\n',
    },
    {
        name: 'LegMarketDisruption',
        abbrName: 'MktDsrptn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4210,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41462,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41463,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41464,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41465,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41466,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4211,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4212,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4213,
            },
        ],
        description:
            'The LegMarketDisruption component is a subcomponent of the InstrumentLeg used to specify the market disruption provisions of the swap.\n\n',
    },
    {
        name: 'LegOptionExercise',
        abbrName: 'OptExer',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '211',
        category: 'Common',
        id: 4214,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41481,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41482,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41483,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41484,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41485,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41486,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41487,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41488,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41489,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41490,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42391,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4360,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4216,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4219,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4428,
            },
        ],
        description:
            'The LegOptionExercise component is a subcomponent of the InstrumentLeg component used to specify option exercise provisions. Its purpose is to identify the opportunities and conditions for exercise, e.g. the schedule of dates on which exercise is allowed. The embedded LegOptionExerciseExpiration component is used to terminate the opportunity for exercise.\n\n',
    },
    {
        name: 'LegOptionExerciseDates',
        abbrName: 'Dts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4216,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41493,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41494,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41495,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41496,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41497,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41498,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41499,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41500,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41501,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41502,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41503,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41504,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41505,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41506,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41507,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41508,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41509,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41510,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41511,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4215,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4217,
            },
        ],
        description:
            'The LegOptionExerciseDates component is a subcomponent of the LegOptionExercise component used to specify option exercise dates.\n\n',
    },
    {
        name: 'LegOptionExerciseExpiration',
        abbrName: 'Exp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '211',
        category: 'Common',
        id: 4219,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41517,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41518,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41519,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41520,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41521,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41522,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41523,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41524,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41525,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41526,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4218,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4220,
            },
        ],
        description:
            'The LegOptionExerciseExpiration component is a subcomponent of the LegOptionExercise component used to specify option exercise expiration dates and times. The purpose of LegOptionExercise is to identify the scheduled opportunities for exercise. LegOptionExerciseExpiration identifies the end of the schedule.\n\n',
    },
    {
        name: 'LegPricingDateTime',
        abbrName: 'PxngDtTm',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4229,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41609,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41610,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41611,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41612,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41613,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4228,
            },
        ],
        description:
            'The LegPricingDateTime component is a subcomponent of InstrumentLeg used to specify an adjusted or unadjusted pricing or fixing date and optionally the time, e.g. for a commodity or FX forward trade.\n\n',
    },
    {
        name: 'LegStreamCommodity',
        abbrName: 'Cmdty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4237,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41648,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41649,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41650,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41651,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41652,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41653,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41654,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '193',
                id: 42588,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41655,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41656,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41657,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41658,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41659,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41660,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41661,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41662,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41663,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41664,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41665,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41666,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41667,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41668,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41669,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41670,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41671,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41672,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41673,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4238,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4207,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4239,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4236,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4242,
            },
        ],
        description:
            'LegStreamCommodity is a subcomponent of the LegStream component used to identify and describe the underlying commodity.\n\n',
    },
    {
        name: 'UnderlyingComplexEventRelativeDate',
        abbrName: 'ReltvDt',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4251,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41739,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41740,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41741,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41742,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41743,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41744,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41745,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41746,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41747,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4250,
            },
        ],
        description:
            'UnderlyingComplexEventRelativeDate is a subcomponent of UnderlyingComplexEvents for specifying the event date and time for an FX or Calendar Spread option or the payout date for a Barrier or Knock option.\n\n',
    },
    {
        name: 'UnderlyingDeliveryStream',
        abbrName: 'DlvryStrm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4257,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41777,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41778,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41779,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41780,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41781,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 42196,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '179',
                id: 42197,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41782,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41783,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41784,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41785,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41786,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41587,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41787,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41788,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41789,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41790,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41791,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41792,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41793,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41794,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41795,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41796,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41797,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41798,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41799,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 43096,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4260,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4259,
            },
        ],
        description:
            'The UnderlyingDeliveryStream component is a subcomponent of the UnderlyingStream used to detail the attributes of a physical delivery stream in a swap.\n\n',
    },
    {
        name: 'UnderlyingOptionExercise',
        abbrName: 'OptExer',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '211',
        category: 'Common',
        id: 4261,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41810,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41811,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41812,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41813,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41814,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41815,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41816,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41817,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41818,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41819,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42887,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4424,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4263,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4266,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4429,
            },
        ],
        description:
            'The UnderlyingOptionExercise component is a subcomponent of the UnderlyingInstrument component used to specify option exercise provisions. Its purpose is to identify the opportunities and conditions for exercise, e.g. the schedule of dates on which exercise is allowed. The embedded UnderlyingOptionExerciseExpiration component is used to terminate the opportunity for exercise.\n\n',
    },
    {
        name: 'UnderlyingOptionExerciseDates',
        abbrName: 'Dts',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4263,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41822,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41823,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41824,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41825,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41826,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41827,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41828,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41829,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41830,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41831,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41832,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41833,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41834,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41835,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41836,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41837,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41838,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41839,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41840,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4262,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4264,
            },
        ],
        description:
            'The UnderlyingOptionExerciseDate component is a subcomponent of the UnderlyingOptionExercise component used to specify option exercise dates.\n\n',
    },
    {
        name: 'UnderlyingOptionExerciseExpiration',
        abbrName: 'Exp',
        updated: 'FIX.5.0SP2',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        updatedEP: '211',
        category: 'Common',
        id: 4266,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41846,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41847,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41848,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41849,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41850,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41851,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41852,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41853,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41854,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41855,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4265,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4267,
            },
        ],
        description:
            'The UnderlyingOptionExerciseExpiration component is a subcomponent of the UnderlyingOptionExercise component used to specify option exercise expiration dates and times. The purpose of UnderlyingOptionExercise is to identify the scheduled opportunities for exercise. UnderlyingOptionExerciseExpiration identifies the end of the schedule.\n\n',
    },
    {
        name: 'UnderlyingMarketDisruption',
        abbrName: 'MktDsrptn',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4268,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41859,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41860,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41861,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41862,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41863,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4269,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4270,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4271,
            },
        ],
        description:
            'The UnderlyingMarketDisruption component is a subcomponent of the UnderlyingInstrument used to specify the market disruption provisions of the swap.\n\n',
    },
    {
        name: 'UnderlyingPricingDateTime',
        abbrName: 'PxngDtTm',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4278,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41949,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41950,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41951,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41952,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41953,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4277,
            },
        ],
        description:
            'The UnderlyingPricingDateTime component is a subcomponent of UnderlyingInstrument used to specify an adjusted or unadjusted pricing or fixing date and optionally the time, e.g. for a commodity or FX forward trade.\n\n',
    },
    {
        name: 'UnderlyingStreamCommodity',
        abbrName: 'Cmdty',
        addedEP: '169',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4281,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41964,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41965,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41966,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41967,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41968,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41969,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41970,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '193',
                id: 42589,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41971,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41972,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41973,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41974,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41975,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41976,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41977,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41978,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41979,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41980,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41981,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41982,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41983,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41984,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41985,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41986,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41987,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41988,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 41989,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4282,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4258,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4283,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4280,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '169',
                id: 4286,
            },
        ],
        description:
            'UnderlyingStreamCommodity is a subcomponent of the UnderlyingStream component used to identify and describe the underlying commodity.\n\n',
    },
    {
        name: 'UnderlyingProvisionCashSettlPaymentDates',
        abbrName: 'CashSettlPmtDts',
        updated: 'FIX.5.0SP2',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        updatedEP: '208',
        category: 'Common',
        id: 4298,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42092,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42093,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42094,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42095,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42096,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42097,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42098,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4309,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4299,
            },
        ],
        description:
            'The UnderlyingProvisionCashSettlPaymentDates component is a sub-component within the UnderlyingProvisionGrp component used to report the cash settlement payment dates defined in the provision.\n\n',
    },
    {
        name: 'UnderlyingProvisionCashSettlQuoteSource',
        abbrName: 'CashSettlQteSrc',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4300,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42102,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42103,
            },
        ],
        description:
            'The UnderlyingProvisionCashSettlQuoteSource is a subcomponent of the UnderlyingProvisionGrp component used to specify the reference source for currency or rate quote for cash settlement purposes.\n\n',
    },
    {
        name: 'UnderlyingProvisionCashSettlValueDates',
        abbrName: 'CashSettlValDts',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4301,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42104,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42105,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42106,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42107,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42108,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42109,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42110,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42111,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4310,
            },
        ],
        description:
            'The UnderlyingProvisionCashSettlValueDates is a subcomponent within the UnderlyingProvisionGrp component used to report the cash settlement value date and time defined in the provision.\n\n',
    },
    {
        name: 'UnderlyingProvisionOptionExerciseDates',
        abbrName: 'OptExerDts',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4303,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42115,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42116,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42117,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42118,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42119,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42120,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42121,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42122,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42123,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42124,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42125,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42126,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42127,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42128,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42129,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42130,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42131,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42132,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4311,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4302,
            },
        ],
        description:
            'The UnderlyingProvisionOptionExerciseDates is a subcomponent within the UnderlyingProvisionGrp component used to report the option exercise dates and times defined in the provision.\n\n',
    },
    {
        name: 'UnderlyingProvisionOptionExpirationDate',
        abbrName: 'OptExpDt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4304,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42133,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42134,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42135,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42136,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42137,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42138,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42139,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42140,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42141,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 4312,
            },
        ],
        description:
            'The UnderlyingProvisionOptionExerciseDate is a subcomponent within the UnderlyingProvisionGrp component used to report the option expiration date and times defined in the provision.\n\n',
    },
    {
        name: 'UnderlyingProvisionOptionRelevantUnderlyingDate',
        abbrName: 'OptRelvntUndlyDt',
        addedEP: '187',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4305,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42142,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42143,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42144,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42145,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42146,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42147,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '187',
                id: 42148,
            },
        ],
        groupRef: [
            {
                updated: 'FIX.Latest',
                addedEP: '187',
                added: 'FIX.5.0SP2',
                updatedEP: '282',
                id: 4313,
            },
        ],
        description:
            'The UnderlyingProvisionOptionRelevantUnderlyingDate is a subcomponent within the UnderlyingProvisionGrp component used to report the option relevant underlying date defined in the provision.\n\n',
    },
    {
        name: 'MDStatisticParameters',
        abbrName: 'StatsPrm',
        addedEP: '191',
        added: 'FIX.5.0SP2',
        category: 'MarketData',
        id: 2250,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2456,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2457,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2458,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2459,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2454,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2455,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2481,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2482,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 264,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2460,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2461,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2462,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2463,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2464,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2465,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2466,
                description:
                    'Conditionally required if/when MDStatisticIntervalUnit(2467) is specified.\n\nConditionally required when MDStatisticIntervalType(2464) = 1 (Sliding window) or 2 (Sliding window peak).',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2467,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2468,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2469,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2470,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2471,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 2472,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '236',
                id: 2584,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 1815,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 40,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 59,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 276,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 277,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 54,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 578,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 336,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '191',
                id: 625,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 1024,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 2711,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 338,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 1022,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 1629,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 1916,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '231',
                id: 1057,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '236',
                id: 1008,
            },
        ],
        description:
            'This component comprises all parameters that can be used to describe the market data statistics. These can be part of the request as well as the response. All parameters defined on the MarketDataStatisticsRequest(35=DO) message should be echoed in the MarketDataStatisticsReport(35=DP) message as the latter could also be sent unsolicited.\n\nThe general category and the entities involved in the statistics are defined by MDStatisticType(2456), MDStatisticScope(2457), and MDStatisticIntervalType(2464) and must always be specified. The remaining fields are optional and restrict the data range in one way or another. The time range for the data can either be specified in terms of an interval for which the statistics are typically calculated on a regular basis or in terms of an absolute date and/or time range.\n\nMDStatisticScope(2457), MDStatisticSubScope(2458) and MDStatisticScopeType(2459) form a set of scope relationships to filter further the type of statistic being requested or being provided.\n\nIt should be noted that some of the enumeration values for MDStatisticScopeType(2459) may not be applicable or useful for a given MDStatisticScope(2457) - e.g. MDStatisticScopeType(2459)=4 (Downward move) is more applicable to prices than to orders or trades.',
    },
    {
        name: 'LegFinancingDetails',
        abbrName: 'FinDetls',
        addedEP: '192',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 2251,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2497,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2498,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2499,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2496,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2495,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2953,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2511,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2510,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2512,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2509,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2500,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2502,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2501,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2503,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2507,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2505,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2494,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2493,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2514,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2513,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2506,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2504,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 2508,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 4315,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 4316,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '192',
                id: 4317,
            },
        ],
        description:
            'Component block is optionally used for financial transactions where legal contracts, master agreements or master confirmations are to be referenced. This component identifies the legal agreement under which the deal was made and other unique characteristics of the transaction. For example, the LegAgreementDesc(2497) field refers to base standard documents such as MRA 1996 Repurchase Agreement, GMRA 2000 Bills Transaction (U.K.), MSLA 1993 Securities Loan - Amended 1998, for example.\n\n',
    },
    {
        name: 'CashSettlDate',
        abbrName: 'SettlDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4318,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42207,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42208,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42209,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42210,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42211,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42212,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42213,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4319,
            },
        ],
        description:
            'The CashSettlDate component is a subcomponent within the CashSettlTermGrp component used to report the cash settlement date defined in the settlement provision.\n\n',
    },
    {
        name: 'DividendAccrualFloatingRate',
        abbrName: 'AcrlFloat',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4320,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42218,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42219,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42220,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42221,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42222,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42223,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42224,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42225,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42226,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42227,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42228,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42229,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42230,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42231,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42232,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42233,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42234,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42235,
            },
        ],
        description:
            'The DividendAccrualFloatingRate component is a subcomponent of DividendConditions used to define the dividend accrual floating rate attributes of dividend payment conditions.\n\n',
    },
    {
        name: 'DividendAccrualPaymentDate',
        abbrName: 'AcrlPmtDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4322,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42238,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42239,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42240,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42241,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42242,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42243,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42244,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4321,
            },
        ],
        description:
            'The DividendAccrualPaymentDate component is a subcomponent of DividendConditions used to report the dividend accrual payment date.\n\n',
    },
    {
        name: 'DividendConditions',
        abbrName: 'DividendConds',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4323,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42245,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42246,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42247,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42248,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42249,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42250,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42251,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42252,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42253,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42254,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42255,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42256,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42257,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42258,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42259,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42260,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42261,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42262,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42263,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42264,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4326,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4324,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4320,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4322,
            },
        ],
        description:
            "The DividendConditions component is a subcomponent of PaymentStream used to specify the conditions' valuations and dates governing the payment of dividends.\n\n",
    },
    {
        name: 'DividendFXTriggerDate',
        abbrName: 'FXTrgrDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4324,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42265,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42266,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42267,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42268,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42269,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42270,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42271,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4325,
            },
        ],
        description:
            'The DividendFXTriggerDate component is a subcomponent of DividendConditions used to report the dividend date when a foreign exchange trade is triggered.\n\n',
    },
    {
        name: 'LegCashSettlDate',
        abbrName: 'SettlDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4328,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42299,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42300,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42301,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42302,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42303,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42304,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42305,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4329,
            },
        ],
        description:
            'The LegCashSettlDate component is a subcomponent within the LegCashSettlTermGrp component used to report the cash settlement date defined in the settlement provision.\n\n',
    },
    {
        name: 'LegDividendAccrualFloatingRate',
        abbrName: 'AcrlFloat',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4331,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42312,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42313,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42314,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42315,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42316,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42317,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42318,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42319,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42320,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42321,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42322,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42323,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42324,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42325,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42326,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42327,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42328,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42329,
            },
        ],
        description:
            'The LegDividendAccrualFloatingRate component is a subcomponent of LegDividendConditions used to define the dividend accrual floating rate attributes of dividend payment conditions.\n\n',
    },
    {
        name: 'LegDividendAccrualPaymentDate',
        abbrName: 'AcrlPmtDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4332,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42330,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42331,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42332,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42333,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42334,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42335,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42336,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4330,
            },
        ],
        description:
            'The LegDividendAccrualPaymentDate component is a subcomponent of LegDividendConditions used to report the dividend accrual payment date.\n\n',
    },
    {
        name: 'LegDividendConditions',
        abbrName: 'DividendConds',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4333,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42337,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42338,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42339,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42340,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42341,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42342,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42343,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42344,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42345,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42346,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42347,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42348,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42349,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42350,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42351,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42352,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42353,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42354,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42355,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42356,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4336,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4334,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4331,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4332,
            },
        ],
        description:
            "The LegDividendConditions component is a subcomponent of LegPaymentStream used to specify the conditions' valuations and dates governing the payment of dividends.\n\n",
    },
    {
        name: 'LegDividendFXTriggerDate',
        abbrName: 'FXTrgrDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4334,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42357,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42358,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42359,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42360,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42361,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42362,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42363,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4335,
            },
        ],
        description:
            'The LegDividendFXTriggerDate component is a subcomponent of LegDividendConditions used to report the dividend date when a foreign exchange trade is triggered.\n\n',
    },
    {
        name: 'LegOptionExerciseMakeWholeProvision',
        abbrName: 'MakeWhole',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4428,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42392,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42393,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42394,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42395,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42396,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42397,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42398,
            },
        ],
        description:
            'LegOptionExerciseMakeWholeProvision is a subcomponent of the LegOptionExercise component used to specify the set of rules of maintaining balance when an option is exercised.\n\nA "make whole" provision seeks to penalize the the option buyer, i.e. make the seller "whole", if the buyer exercises the option prior to the make whole date, e.g. the early call date of a convertible bond.',
    },
    {
        name: 'LegPaymentStreamCompoundingDates',
        abbrName: 'CmpndgDts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4339,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42408,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42409,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42410,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42411,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42412,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42413,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42414,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42415,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42416,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42417,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42418,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4340,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4338,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4343,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4341,
            },
        ],
        description:
            'LegPaymentStreamCompoundingDates is a subcomponent of the LegPaymentStream component used to specify the compounding dates of the stream - either specific, relative or periodic dates.\n\n',
    },
    {
        name: 'LegPaymentStreamCompoundingEndDate',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4341,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42421,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42422,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42423,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42424,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42425,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42426,
            },
        ],
        description:
            'LegPaymentStreamCompoundingEndDate is a subcomponent of the LegPaymentStreamCompoundingDates component used to specify the end date for compounding.\n\n',
    },
    {
        name: 'LegPaymentStreamCompoundingFloatingRate',
        abbrName: 'CmpndgFloat',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4342,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42427,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42428,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42429,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42430,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42431,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42432,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42433,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42434,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42435,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42436,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42437,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42438,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42439,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42440,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42441,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42442,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42443,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42444,
            },
        ],
        description:
            'LegPaymentStreamCompoundingFloatingRate is a subcomponent of the LegPaymentStream component used to report the parameters for determining the compounding floating rate of the stream.\n\n',
    },
    {
        name: 'LegPaymentStreamCompoundingStartDate',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4343,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42445,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42446,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42447,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42448,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42449,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42450,
            },
        ],
        description:
            'LegPaymentStreamCompoundingStartDate is a subcomponent of the LegPaymentStreamCompoundingDates component used to specify the start date for compounding.\n\n',
    },
    {
        name: 'LegPaymentStreamFormulaImage',
        abbrName: 'Img',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4344,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42451,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42452,
            },
        ],
        description:
            'LegPaymentStreamFormulaImage is a subcomponent of the LegPaymentStreamFormula component used to include a base64Binary-encoded image clip of the formula.\n\n',
    },
    {
        name: 'LegPaymentStreamFinalPricePaymentDate',
        abbrName: 'FnlPxPmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4345,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42453,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42454,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42455,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42456,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42457,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42458,
            },
        ],
        description:
            'LegPaymentStreamFinalPricePaymentDate is a subcomponent of the LegPaymentStreamPaymentDates component used to specify the final price payment date, e.g. for an equity return swap.\n\n',
    },
    {
        name: 'LegPaymentStreamFormula',
        abbrName: 'Frmla',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4347,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42482,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42483,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42484,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4348,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4344,
            },
        ],
        description:
            'LegPaymentStreamFormula is a subcomponent of the LegPaymentStreamFloatingRate component used to report the parameters for determining the floating rate of the stream e.g. for equity swaps.\n\n',
    },
    {
        name: 'LegPaymentStubEndDate',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4349,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42488,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42489,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42490,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42491,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42492,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42493,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42494,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4350,
            },
        ],
        description:
            'LegPaymentStubEndDate is a subcomponent of the LegPaymentStubGrp component used to specify the end date of the payment stub.\n\n',
    },
    {
        name: 'LegPaymentStubStartDate',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4351,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42497,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42498,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42499,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42500,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42501,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42502,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42503,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4352,
            },
        ],
        description:
            'LegPaymentStubStartDate is a subcomponent of the LegPaymentStubGrp component used to specify the start date of the payment stub.\n\n',
    },
    {
        name: 'LegSettlMethodElectionDate',
        abbrName: 'SettlMethDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4360,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42574,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42575,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42576,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42577,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42578,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42579,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42580,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4361,
            },
        ],
        description:
            'The LegSettlMethodElectionDate component is a subcomponent within the LegOptionExercise component used to report the settlement method election date.\n\n',
    },
    {
        name: 'OptionExerciseMakeWholeProvision',
        abbrName: 'MakeWhole',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4362,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42591,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42592,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42593,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42594,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42595,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42596,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42597,
            },
        ],
        description:
            'OptionExerciseMakeWholeProvision is a subcomponent of the OptionExercise component used to specify the set of rules of maintaining balance when an option is exercised.\n\nA "make whole" provision seeks to penalize the the option buyer, i.e. make the seller "whole", if the buyer exercises the option prior to the make whole date, e.g. the early call date of a convertible bond.',
    },
    {
        name: 'PaymentStreamCompoundingDates',
        abbrName: 'CmpndgDts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4364,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42609,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42610,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42611,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42612,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42613,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42614,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42615,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42616,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42617,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42618,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42619,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4365,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4363,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4368,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4366,
            },
        ],
        description:
            'PaymentStreamCompoundingDates is a subcomponent of the PaymentStream component used to specify the compounding dates of the stream - either specific, relative or periodic dates.\n\n',
    },
    {
        name: 'PaymentStreamCompoundingEndDate',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4366,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42622,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42623,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42624,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42625,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42626,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42627,
            },
        ],
        description:
            'PaymentStreamCompoundingEndDate is a subcomponent of the PaymentStreamCompoundingDates component used to specify the end date for compounding.\n\n',
    },
    {
        name: 'PaymentStreamCompoundingFloatingRate',
        abbrName: 'CmpndgFloat',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4367,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42628,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42629,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42630,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42631,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42632,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42633,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42634,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42635,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42636,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42637,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42638,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42639,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42640,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42641,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42642,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42643,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42644,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42645,
            },
        ],
        description:
            'PaymentStreamCompoundingFloatingRate is a subcomponent of the PaymentStream component used to report the parameters for determining the compounding floating rate of the stream.\n\n',
    },
    {
        name: 'PaymentStreamCompoundingStartDate',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4368,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42646,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42647,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42648,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42649,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42650,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42651,
            },
        ],
        description:
            'PaymentStreamCompoundingStartDate is a subcomponent of the PaymentStreamCompoundingDates component used to specify the start date for compounding.\n\n',
    },
    {
        name: 'PaymentStreamFormulaImage',
        abbrName: 'Img',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4369,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42652,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42653,
            },
        ],
        description:
            'PaymentStreamFormulaImage is a subcomponent of the PaymentStreamFormula component used to include a base64Binary-encoded image clip of the formula.\n\n',
    },
    {
        name: 'PaymentStreamFinalPricePaymentDate',
        abbrName: 'FnlPxPmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4370,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42654,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42655,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42656,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42657,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42658,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42659,
            },
        ],
        description:
            'PaymentStreamFinalPricePaymentDate is a subcomponent of the PaymentStreamPaymentDates component used to specify the final price payment date, e.g. for an equity return swap.\n\n',
    },
    {
        name: 'PaymentStreamFormula',
        abbrName: 'Frmla',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4373,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42686,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42687,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42688,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4372,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4369,
            },
        ],
        description:
            'PaymentStreamFormula is a subcomponent of the PaymentStreamFloatingRate component used to report the parameters for determining the floating rate of the stream e.g. for equity swaps.\n\n',
    },
    {
        name: 'PaymentStubEndDate',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4374,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42689,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42690,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42691,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42692,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42693,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42694,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42695,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4375,
            },
        ],
        description:
            'PaymentStubEndDate is a subcomponent of the PaymentStubGrp component used to specify the end date of the payment stub.\n\n',
    },
    {
        name: 'PaymentStubStartDate',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4376,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42698,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42699,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42700,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42701,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42702,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42703,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42704,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4377,
            },
        ],
        description:
            'PaymentStubStartDate is a subcomponent of the PaymentStubGrp component used to specify the start date of the payment stub.\n\n',
    },
    {
        name: 'SettlMethodElectionDate',
        abbrName: 'SettlMethDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4386,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42777,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42778,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42779,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42780,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42781,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42782,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42783,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4385,
            },
        ],
        description:
            'The SettlMethodElectionDate component is a subcomponent within the OptionExercise component used to report the settlement method election date.\n\n',
    },
    {
        name: 'UnderlyingCashSettlDate',
        abbrName: 'SettlDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4388,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42790,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42791,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42792,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42793,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42794,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42795,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42796,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4387,
            },
        ],
        description:
            'The UnderlyingCashSettlDate component is a subcomponent within the UnderlyingCashSettlTermGrp component used to report the cash settlement date defined in the settlement provision.\n\n',
    },
    {
        name: 'UnderlyingDividendAccrualFloatingRate',
        abbrName: 'AcrlFloat',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4390,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42801,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42802,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42803,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42804,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42805,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42806,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42807,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42808,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42809,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42810,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42811,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42812,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42813,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42814,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42815,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42816,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42817,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42818,
            },
        ],
        description:
            'The UnderlyingDividendAccrualFloatingRate component is a subcomponent of UnderlyingDividendConditions used to define the dividend accrual floating rate attributes of dividend payment conditions.\n\n',
    },
    {
        name: 'UnderlyingDividendAccrualPaymentDate',
        abbrName: 'AcrlPmtDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4391,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42819,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42820,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42821,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42822,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42823,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42824,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42825,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4389,
            },
        ],
        description:
            'The UnderlyingDividendAccrualPaymentDate component is a subcomponent of UnderlyingDividendConditions used to report the dividend accrual payment date.\n\n',
    },
    {
        name: 'UnderlyingDividendConditions',
        abbrName: 'DividendConds',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4392,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42826,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42827,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42828,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42829,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42830,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42831,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42832,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42833,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42834,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42835,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42836,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42837,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42838,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42839,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42840,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42841,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42842,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42843,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42844,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42845,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4397,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4393,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4390,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4391,
            },
        ],
        description:
            "The UnderlyingDividendConditions component is a subcomponent of UnderlyingPaymentStream used to specify the conditions' valuations and dates governing the payment of dividends.\n\n",
    },
    {
        name: 'UnderlyingDividendFXTriggerDate',
        abbrName: 'FXTrgrDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4393,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42846,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42847,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42848,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42849,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42850,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42851,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42852,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4394,
            },
        ],
        description:
            'The UnderlyingDividendFXTriggerDate component is a subcomponent of UnderlyingDividendConditions used to report the dividend date when a foreign exchange trade is triggered.\n\n',
    },
    {
        name: 'UnderlyingDividendPayout',
        abbrName: 'DividendPay',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4396,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42860,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42861,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4395,
            },
        ],
        description:
            'UnderlyingDividendPayout is a subcomponent of UnderlyingInstrument used to specify the dividend or coupon payout parameters of an equity or bond underlier.\n\n',
    },
    {
        name: 'UnderlyingOptionExerciseMakeWholeProvision',
        abbrName: 'MakeWhole',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4429,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42888,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42889,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42890,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42891,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42892,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42893,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42894,
            },
        ],
        description:
            'UnderlyingOptionExerciseMakeWholeProvision is a subcomponent of the UnderlyingOptionExercise component used to specify the set of rules of maintaining balance when an option is exercised.\n\nA "make whole" provision seeks to penalize the the option buyer, i.e. make the seller "whole", if the buyer exercises the option prior to the makeWholeDate, e.g. the early call date of a convertible bond.',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingDates',
        abbrName: 'CmpndgDts',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4400,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42904,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42905,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42906,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42907,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42908,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42909,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42910,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42911,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42912,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42913,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42914,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4401,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4399,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4404,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4402,
            },
        ],
        description:
            'UnderlyingPaymentStreamCompoundingDates is a subcomponent of the UnderlyingPaymentStream component used to specify the compounding dates of the stream - either specific, relative or periodic dates.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingEndDate',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4402,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42917,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42918,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42919,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42920,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42921,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42922,
            },
        ],
        description:
            'UnderlyingPaymentStreamCompoundingEndDate is a subcomponent of the UnderlyingPaymentStreamCompoundingDates component used to specify the end date for compounding.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingFloatingRate',
        abbrName: 'CmpndgFloat',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4403,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42923,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42924,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42925,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42926,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42927,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42928,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42929,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42930,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42931,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42932,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42933,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42934,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42935,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42936,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42937,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42938,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42939,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42940,
            },
        ],
        description:
            'UnderlyingPaymentStreamCompoundingFloatingRate is a subcomponent of the UnderlyingPaymentStream component used to report the parameters for determining the compounding floating rate of the stream.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamCompoundingStartDate',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4404,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42941,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42942,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42943,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42944,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42945,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42946,
            },
        ],
        description:
            'UnderlyingPaymentStreamCompoundingStartDate is a subcomponent of the UnderlyingPaymentStreamCompoundingDates component used to specify the start date for compounding.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamFormulaImage',
        abbrName: 'Img',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4405,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42947,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42948,
            },
        ],
        description:
            'UnderlyingPaymentStreamFormulaImage is a subcomponent of the UnderlyingPaymentStreamFormula component used to include a base64Binary-encoded image clip of the formula.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamFinalPricePaymentDate',
        abbrName: 'FnlPxPmt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4406,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42949,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42950,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42951,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42952,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42953,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42954,
            },
        ],
        description:
            'UnderlyingPaymentStreamFinalPricePaymentDate is a subcomponent of the UnderlyingPaymentStreamPaymentDates component used to specify the final price payment date, e.g. for an equity return swap.\n\n',
    },
    {
        name: 'UnderlyingPaymentStreamFormula',
        abbrName: 'Frmla',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4408,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42978,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42979,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42980,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4409,
            },
        ],
        componentRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4405,
            },
        ],
        description:
            'UnderlyingPaymentStreamFormula is a subcomponent of the UnderlyingPaymentStreamFloatingRate component used to report the parameters for determining the floating rate of the stream e.g. for equity swaps.\n\n',
    },
    {
        name: 'UnderlyingPaymentStubEndDate',
        abbrName: 'EndDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4410,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42984,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42985,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42986,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42987,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42988,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42989,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42990,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4411,
            },
        ],
        description:
            'UnderlyingPaymentStubEndDate is a subcomponent of the UnderlyingPaymentStubGrp component used to specify the end date of the payment stub.\n\n',
    },
    {
        name: 'UnderlyingPaymentStubStartDate',
        abbrName: 'StartDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4412,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42993,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42994,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42995,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42996,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42997,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42998,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 42999,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4413,
            },
        ],
        description:
            'UnderlyingPaymentStubStartDate is a subcomponent of the UnderlyingPaymentStubGrp component used to specify the start date of the payment stub.\n\n',
    },
    {
        name: 'UnderlyingRateSpreadSchedule',
        abbrName: 'RtSpreadSched',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4414,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43004,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4415,
            },
        ],
        description:
            'UnderlyingRateSpreadSchedule is a subcomponent of UnderlyingInstrument used to specify the rate spread schedule for a basket underlier.\n\n',
    },
    {
        name: 'UnderlyingSettlMethodElectionDate',
        abbrName: 'SettlMethDt',
        addedEP: '208',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 4424,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43076,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43077,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43078,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43079,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43080,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43081,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 43082,
            },
        ],
        groupRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '208',
                id: 4423,
            },
        ],
        description:
            'The UnderlyingSettlMethodElectionDate component is a subcomponent within the UnderlyingOptionExercise component used to report the settlement method election date.\n\n',
    },
    {
        name: 'FloatingRateIndex',
        abbrName: 'RtNdx',
        updated: 'FIX.5.0SP2',
        addedEP: '235',
        added: 'FIX.5.0SP2',
        updatedEP: '240',
        category: 'Common',
        id: 2264,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2731,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2732,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2730,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2728,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '235',
                id: 2729,
            },
        ],
        description:
            'Used to identify the rate index for a floating rate coupon.\n\nIn the context of MiFID II RTS 23 Annex I Table 3 reference data - statement of the attributes of the index/benchmark of a floating rate security.',
    },
    {
        name: 'AveragePriceDetail',
        abbrName: 'AvgPxDetl',
        addedEP: '240',
        added: 'FIX.5.0SP2',
        category: 'Common',
        id: 1075,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '240',
                id: 2763,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '240',
                id: 2764,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '240',
                id: 2765,
            },
        ],
        description:
            'The AveragePriceDetail component provides average pricing details in a trade report, including the average pricing model and the start and end times of averaging period.\n\n',
    },
    {
        name: 'PostTradePayment',
        abbrName: 'PostTrdPmt',
        addedEP: '249',
        added: 'FIX.5.0SP2',
        category: 'PayManagement',
        id: 2265,
        fieldRef: [
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2824,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2817,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2818,
            },
            {
                added: 'FIX.Latest',
                addedEP: '273',
                id: 2956,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2825,
                presence: 'required',
                description:
                    'The date payment calculations are made. This may be earlier than the date in ClearingBusinessDate(715).\n\nWhen the report is sent unsolicited, this is the payment calculation date as determined by report sender.',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2826,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2827,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2819,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2816,
                presence: 'required',
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2821,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2820,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2815,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2814,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2822,
            },
            {
                added: 'FIX.5.0SP2',
                addedEP: '249',
                id: 2823,
            },
        ],
        description: 'This component specifies the details of a payment between the parties involved.\n\n',
    },
    {
        name: 'SettlTradeDetails',
        abbrName: 'SettlTrdDetls',
        addedEP: '281',
        added: 'FIX.Latest',
        category: 'SettlementStatusManagement',
        id: 2271,
        fieldRef: [
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 664,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 70,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 467,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 793,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 79,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 75,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 80,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 54,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 6,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 423,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 860,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 381,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 118,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 15,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 2897,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 854,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 64,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 119,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 120,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 2899,
            },
        ],
        componentRef: [
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 1003,
            },
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 1016,
            },
        ],
        groupRef: [
            {
                added: 'FIX.Latest',
                addedEP: '281',
                id: 1008,
            },
        ],
        description:
            'SettlTradeDetails component is used to provide the details which can be used to look up a single trade.\n\n',
    },
];
